/* tslint:disable */
/* eslint-disable */
/**
 * 【モニタリング】コミュニケーション機能 メンテ系AP
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 有効フラグ:enum
 * @export
 * @enum {string}
 */

export const DomEnableFlag = {
    Enabled: 'enabled',
    Disabled: 'disabled'
} as const;

export type DomEnableFlag = typeof DomEnableFlag[keyof typeof DomEnableFlag];


/**
 * 組織種別:enum
 * @export
 * @enum {string}
 */

export const DomOrganizationType = {
    Primary: 'primary',
    Secondary: 'secondary',
    Admin: 'admin',
    Crew: 'crew'
} as const;

export type DomOrganizationType = typeof DomOrganizationType[keyof typeof DomOrganizationType];


/**
 * 
 * @export
 * @interface DownloadHistoriesCsvRequest
 */
export interface DownloadHistoriesCsvRequest {
    /**
     * サービスID:number
     * @type {number}
     * @memberof DownloadHistoriesCsvRequest
     */
    'serviceId'?: number;
    /**
     * GC番号:string
     * @type {string}
     * @memberof DownloadHistoriesCsvRequest
     */
    'gcNo'?: string;
    /**
     * 号機番号:string
     * @type {string}
     * @memberof DownloadHistoriesCsvRequest
     */
    'gouki'?: string;
    /**
     * 電計番号:string
     * @type {string}
     * @memberof DownloadHistoriesCsvRequest
     */
    'denkei'?: string;
    /**
     * 対象先名称
     * @type {string}
     * @memberof DownloadHistoriesCsvRequest
     */
    'name'?: string | null;
    /**
     * 隊員番号
     * @type {string}
     * @memberof DownloadHistoriesCsvRequest
     */
    'crewNo'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof DownloadHistoriesCsvRequest
     */
    'from'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof DownloadHistoriesCsvRequest
     */
    'to'?: string;
}
/**
 * 
 * @export
 * @interface EntityAdministrationType
 */
export interface EntityAdministrationType {
    /**
     * 組織ID:number
     * @type {number}
     * @memberof EntityAdministrationType
     */
    'organizationId'?: number;
    /**
     * 管理種別/管理組織名
     * @type {string}
     * @memberof EntityAdministrationType
     */
    'name'?: string;
    /**
     * 
     * @type {EntityCapabilities}
     * @memberof EntityAdministrationType
     */
    'capabilities'?: EntityCapabilities;
}
/**
 * 
 * @export
 * @interface EntityAdministrationalHistory
 */
export interface EntityAdministrationalHistory {
    /**
     * 会議ID:uuid
     * @type {string}
     * @memberof EntityAdministrationalHistory
     */
    'meetingId'?: string;
    /**
     * サービス名
     * @type {string}
     * @memberof EntityAdministrationalHistory
     */
    'serviceName'?: string;
    /**
     * 会議室名
     * @type {string}
     * @memberof EntityAdministrationalHistory
     */
    'roomName'?: string;
    /**
     * 対象先名
     * @type {string}
     * @memberof EntityAdministrationalHistory
     */
    'locationName'?: string;
    /**
     * GC番号:string
     * @type {string}
     * @memberof EntityAdministrationalHistory
     */
    'gcNo'?: string;
    /**
     * 号機番号:string
     * @type {string}
     * @memberof EntityAdministrationalHistory
     */
    'gouki'?: string;
    /**
     * 電計番号:string
     * @type {string}
     * @memberof EntityAdministrationalHistory
     */
    'denkei'?: string;
    /**
     * 一次専門組織名
     * @type {string}
     * @memberof EntityAdministrationalHistory
     */
    'primaryOrganizationName'?: string;
    /**
     * 一次専門組織ユーザ名
     * @type {string}
     * @memberof EntityAdministrationalHistory
     */
    'primaryOrganizationMemberName'?: string;
    /**
     * 二次専門組織名
     * @type {string}
     * @memberof EntityAdministrationalHistory
     */
    'secondaryOrganizationName'?: string;
    /**
     * 二次専門組織ユーザ名
     * @type {string}
     * @memberof EntityAdministrationalHistory
     */
    'secondaryOrganizationMemberName'?: string;
    /**
     * 隊員番号
     * @type {string}
     * @memberof EntityAdministrationalHistory
     */
    'crewNo'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrationalHistory
     */
    'startAt'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrationalHistory
     */
    'finishAt'?: string;
    /**
     * 録画映像の有無
     * @type {boolean}
     * @memberof EntityAdministrationalHistory
     */
    'recorded'?: boolean;
}
/**
 * 
 * @export
 * @interface EntityAdministrationalLocation
 */
export interface EntityAdministrationalLocation {
    /**
     * 契約先ID:number
     * @type {number}
     * @memberof EntityAdministrationalLocation
     */
    'locationId'?: number;
    /**
     * 
     * @type {Array<EntityAdministrationalLocationServicesInner>}
     * @memberof EntityAdministrationalLocation
     */
    'services'?: Array<EntityAdministrationalLocationServicesInner>;
    /**
     * 対象先名
     * @type {string}
     * @memberof EntityAdministrationalLocation
     */
    'name'?: string;
    /**
     * GC番号:string
     * @type {string}
     * @memberof EntityAdministrationalLocation
     */
    'gcNo'?: string;
    /**
     * 号機番号:string
     * @type {string}
     * @memberof EntityAdministrationalLocation
     */
    'gouki'?: string;
    /**
     * 電計番号:string
     * @type {string}
     * @memberof EntityAdministrationalLocation
     */
    'denkei'?: string;
    /**
     * 
     * @type {any}
     * @memberof EntityAdministrationalLocation
     */
    'comment'?: any;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrationalLocation
     */
    'createdAt'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrationalLocation
     */
    'updatedAt'?: string;
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntityAdministrationalLocation
     */
    'updatedById'?: number;
    /**
     * 更新者名
     * @type {string}
     * @memberof EntityAdministrationalLocation
     */
    'updatedByName'?: string;
}
/**
 * 
 * @export
 * @interface EntityAdministrationalLocationForCreate
 */
export interface EntityAdministrationalLocationForCreate {
    /**
     * 
     * @type {Array<EntityAdministrationalLocationForCreateServicesInner>}
     * @memberof EntityAdministrationalLocationForCreate
     */
    'services'?: Array<EntityAdministrationalLocationForCreateServicesInner>;
    /**
     * 対象先名
     * @type {string}
     * @memberof EntityAdministrationalLocationForCreate
     */
    'name'?: string;
    /**
     * GC番号:string
     * @type {string}
     * @memberof EntityAdministrationalLocationForCreate
     */
    'gcNo'?: string;
    /**
     * 号機番号:string
     * @type {string}
     * @memberof EntityAdministrationalLocationForCreate
     */
    'gouki'?: string;
    /**
     * 電計番号:string
     * @type {string}
     * @memberof EntityAdministrationalLocationForCreate
     */
    'denkei'?: string;
    /**
     * 
     * @type {any}
     * @memberof EntityAdministrationalLocationForCreate
     */
    'comment'?: any;
}
/**
 * 
 * @export
 * @interface EntityAdministrationalLocationForCreateServicesInner
 */
export interface EntityAdministrationalLocationForCreateServicesInner {
    /**
     * サービスID:number
     * @type {number}
     * @memberof EntityAdministrationalLocationForCreateServicesInner
     */
    'serviceId'?: number;
    /**
     * 組織ID:number
     * @type {number}
     * @memberof EntityAdministrationalLocationForCreateServicesInner
     */
    'organizationId'?: number;
}
/**
 * 
 * @export
 * @interface EntityAdministrationalLocationForUpdate
 */
export interface EntityAdministrationalLocationForUpdate {
    /**
     * 
     * @type {Array<EntityAdministrationalLocationForCreateServicesInner>}
     * @memberof EntityAdministrationalLocationForUpdate
     */
    'services'?: Array<EntityAdministrationalLocationForCreateServicesInner>;
    /**
     * 対象先名
     * @type {string}
     * @memberof EntityAdministrationalLocationForUpdate
     */
    'name'?: string;
    /**
     * GC番号:string
     * @type {string}
     * @memberof EntityAdministrationalLocationForUpdate
     */
    'gcNo'?: string;
    /**
     * 号機番号:string
     * @type {string}
     * @memberof EntityAdministrationalLocationForUpdate
     */
    'gouki'?: string;
    /**
     * 電計番号:string
     * @type {string}
     * @memberof EntityAdministrationalLocationForUpdate
     */
    'denkei'?: string;
    /**
     * 
     * @type {any}
     * @memberof EntityAdministrationalLocationForUpdate
     */
    'comment'?: any;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrationalLocationForUpdate
     */
    'createdAt'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrationalLocationForUpdate
     */
    'updatedAt'?: string;
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntityAdministrationalLocationForUpdate
     */
    'updatedById'?: number;
    /**
     * 更新者名
     * @type {string}
     * @memberof EntityAdministrationalLocationForUpdate
     */
    'updatedByName'?: string;
}
/**
 * 
 * @export
 * @interface EntityAdministrationalLocationSecondaryOrganizationForCreate
 */
export interface EntityAdministrationalLocationSecondaryOrganizationForCreate {
    /**
     * サービスID:number
     * @type {number}
     * @memberof EntityAdministrationalLocationSecondaryOrganizationForCreate
     */
    'serviceId'?: number;
    /**
     * 
     * @type {EntityAdministrationalSecondaryOrganizationForCreate}
     * @memberof EntityAdministrationalLocationSecondaryOrganizationForCreate
     */
    'organization'?: EntityAdministrationalSecondaryOrganizationForCreate;
    /**
     * 
     * @type {Array<EntityAdministrationalSecondaryMemberForCreate>}
     * @memberof EntityAdministrationalLocationSecondaryOrganizationForCreate
     */
    'members'?: Array<EntityAdministrationalSecondaryMemberForCreate>;
}
/**
 * 
 * @export
 * @interface EntityAdministrationalLocationServicesInner
 */
export interface EntityAdministrationalLocationServicesInner {
    /**
     * サービスID:number
     * @type {number}
     * @memberof EntityAdministrationalLocationServicesInner
     */
    'id'?: number;
    /**
     * サービス名
     * @type {string}
     * @memberof EntityAdministrationalLocationServicesInner
     */
    'name'?: string;
    /**
     * 組織ID:number
     * @type {number}
     * @memberof EntityAdministrationalLocationServicesInner
     */
    'organizationId'?: number;
    /**
     * 一次専門組織名
     * @type {string}
     * @memberof EntityAdministrationalLocationServicesInner
     */
    'organizationName'?: string;
}
/**
 * 
 * @export
 * @interface EntityAdministrationalPrimaryMember
 */
export interface EntityAdministrationalPrimaryMember {
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntityAdministrationalPrimaryMember
     */
    'memberId'?: number;
    /**
     * 名称
     * @type {string}
     * @memberof EntityAdministrationalPrimaryMember
     */
    'name'?: string;
    /**
     * Emailアドレス:string
     * @type {string}
     * @memberof EntityAdministrationalPrimaryMember
     */
    'email'?: string;
    /**
     * sub
     * @type {string}
     * @memberof EntityAdministrationalPrimaryMember
     */
    'sub'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntityAdministrationalPrimaryMember
     */
    'tel'?: string;
    /**
     * パスワード
     * @type {string}
     * @memberof EntityAdministrationalPrimaryMember
     */
    'password'?: string | null;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrationalPrimaryMember
     */
    'createdAt'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrationalPrimaryMember
     */
    'updatedAt'?: string;
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntityAdministrationalPrimaryMember
     */
    'updatedById'?: number;
    /**
     * 更新者名
     * @type {string}
     * @memberof EntityAdministrationalPrimaryMember
     */
    'updatedByName'?: string;
}
/**
 * 
 * @export
 * @interface EntityAdministrationalPrimaryMemberForCreate
 */
export interface EntityAdministrationalPrimaryMemberForCreate {
    /**
     * 氏名
     * @type {string}
     * @memberof EntityAdministrationalPrimaryMemberForCreate
     */
    'name'?: string;
    /**
     * 姓
     * @type {string}
     * @memberof EntityAdministrationalPrimaryMemberForCreate
     */
    'familyName'?: string;
    /**
     * 名
     * @type {string}
     * @memberof EntityAdministrationalPrimaryMemberForCreate
     */
    'givenName'?: string;
    /**
     * Emailアドレス:string
     * @type {string}
     * @memberof EntityAdministrationalPrimaryMemberForCreate
     */
    'email'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntityAdministrationalPrimaryMemberForCreate
     */
    'tel'?: string;
    /**
     * パスワード
     * @type {string}
     * @memberof EntityAdministrationalPrimaryMemberForCreate
     */
    'password'?: string | null;
}
/**
 * 
 * @export
 * @interface EntityAdministrationalPrimaryMemberForUpdate
 */
export interface EntityAdministrationalPrimaryMemberForUpdate {
    /**
     * 氏名
     * @type {string}
     * @memberof EntityAdministrationalPrimaryMemberForUpdate
     */
    'name'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntityAdministrationalPrimaryMemberForUpdate
     */
    'tel'?: string;
    /**
     * パスワード
     * @type {string}
     * @memberof EntityAdministrationalPrimaryMemberForUpdate
     */
    'password'?: string | null;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrationalPrimaryMemberForUpdate
     */
    'createdAt'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrationalPrimaryMemberForUpdate
     */
    'updatedAt'?: string;
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntityAdministrationalPrimaryMemberForUpdate
     */
    'updatedById'?: number;
    /**
     * 更新者名
     * @type {string}
     * @memberof EntityAdministrationalPrimaryMemberForUpdate
     */
    'updatedByName'?: string;
}
/**
 * 
 * @export
 * @interface EntityAdministrationalPrimaryOrganization
 */
export interface EntityAdministrationalPrimaryOrganization {
    /**
     * 組織ID:number
     * @type {number}
     * @memberof EntityAdministrationalPrimaryOrganization
     */
    'organizationId'?: number;
    /**
     * サービスID:number
     * @type {number}
     * @memberof EntityAdministrationalPrimaryOrganization
     */
    'serviceId'?: number;
    /**
     * 組織名称
     * @type {string}
     * @memberof EntityAdministrationalPrimaryOrganization
     */
    'name'?: string;
    /**
     * 
     * @type {DomOrganizationType}
     * @memberof EntityAdministrationalPrimaryOrganization
     */
    'type'?: DomOrganizationType;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntityAdministrationalPrimaryOrganization
     */
    'tel'?: string;
    /**
     * 所属ユーザ数
     * @type {number}
     * @memberof EntityAdministrationalPrimaryOrganization
     */
    'memberNum'?: number;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrationalPrimaryOrganization
     */
    'createdAt'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrationalPrimaryOrganization
     */
    'updatedAt'?: string;
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntityAdministrationalPrimaryOrganization
     */
    'updatedById'?: number;
    /**
     * 更新者名
     * @type {string}
     * @memberof EntityAdministrationalPrimaryOrganization
     */
    'updatedByName'?: string;
}


/**
 * 
 * @export
 * @interface EntityAdministrationalPrimaryOrganizationForCreate
 */
export interface EntityAdministrationalPrimaryOrganizationForCreate {
    /**
     * サービスID:number
     * @type {number}
     * @memberof EntityAdministrationalPrimaryOrganizationForCreate
     */
    'serviceId'?: number;
    /**
     * 組織名称
     * @type {string}
     * @memberof EntityAdministrationalPrimaryOrganizationForCreate
     */
    'name'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntityAdministrationalPrimaryOrganizationForCreate
     */
    'tel'?: string;
}
/**
 * 
 * @export
 * @interface EntityAdministrationalPrimaryOrganizationForUpdate
 */
export interface EntityAdministrationalPrimaryOrganizationForUpdate {
    /**
     * 組織名称
     * @type {string}
     * @memberof EntityAdministrationalPrimaryOrganizationForUpdate
     */
    'name'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntityAdministrationalPrimaryOrganizationForUpdate
     */
    'tel'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrationalPrimaryOrganizationForUpdate
     */
    'createdAt'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrationalPrimaryOrganizationForUpdate
     */
    'updatedAt'?: string;
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntityAdministrationalPrimaryOrganizationForUpdate
     */
    'updatedById'?: number;
    /**
     * 更新者名
     * @type {string}
     * @memberof EntityAdministrationalPrimaryOrganizationForUpdate
     */
    'updatedByName'?: string;
}
/**
 * 
 * @export
 * @interface EntityAdministrationalSecondaryMember
 */
export interface EntityAdministrationalSecondaryMember {
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntityAdministrationalSecondaryMember
     */
    'memberId'?: number;
    /**
     * 名称
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMember
     */
    'name'?: string;
    /**
     * Emailアドレス:string
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMember
     */
    'email1'?: string;
    /**
     * Emailアドレス:string
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMember
     */
    'email2'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMember
     */
    'tel1'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMember
     */
    'tel2'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMember
     */
    'tel3'?: string;
    /**
     * 電話番号/SMS（E.164）
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMember
     */
    'sms'?: string;
    /**
     * 
     * @type {any}
     * @memberof EntityAdministrationalSecondaryMember
     */
    'comment'?: any;
    /**
     * 担当対象先数
     * @type {number}
     * @memberof EntityAdministrationalSecondaryMember
     */
    'numLocations'?: number;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMember
     */
    'createdAt'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMember
     */
    'updatedAt'?: string;
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntityAdministrationalSecondaryMember
     */
    'updatedById'?: number;
    /**
     * 更新者名
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMember
     */
    'updatedByName'?: string;
}
/**
 * 
 * @export
 * @interface EntityAdministrationalSecondaryMemberForCreate
 */
export interface EntityAdministrationalSecondaryMemberForCreate {
    /**
     * 氏名
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForCreate
     */
    'name'?: string;
    /**
     * 姓
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForCreate
     */
    'familyName'?: string;
    /**
     * 名
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForCreate
     */
    'givenName'?: string;
    /**
     * Emailアドレス:string
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForCreate
     */
    'email1'?: string;
    /**
     * Emailアドレス:string
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForCreate
     */
    'email2'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForCreate
     */
    'tel1'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForCreate
     */
    'tel2'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForCreate
     */
    'tel3'?: string;
    /**
     * 電話番号/SMS（E.164）
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForCreate
     */
    'sms'?: string;
    /**
     * 
     * @type {any}
     * @memberof EntityAdministrationalSecondaryMemberForCreate
     */
    'comment'?: any;
    /**
     * パスワード
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForCreate
     */
    'password'?: string | null;
}
/**
 * 
 * @export
 * @interface EntityAdministrationalSecondaryMemberForLocation
 */
export interface EntityAdministrationalSecondaryMemberForLocation {
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntityAdministrationalSecondaryMemberForLocation
     */
    'memberId'?: number;
    /**
     * 所属する二次専門組織の名称
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForLocation
     */
    'organizationName'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof EntityAdministrationalSecondaryMemberForLocation
     */
    'serviceIds'?: Array<number>;
    /**
     * 名称
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForLocation
     */
    'name'?: string;
    /**
     * Emailアドレス:string
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForLocation
     */
    'email1'?: string;
    /**
     * Emailアドレス:string
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForLocation
     */
    'email2'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForLocation
     */
    'tel1'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForLocation
     */
    'tel2'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForLocation
     */
    'tel3'?: string;
    /**
     * 電話番号/SMS（E.164）
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForLocation
     */
    'sms'?: string;
    /**
     * 
     * @type {any}
     * @memberof EntityAdministrationalSecondaryMemberForLocation
     */
    'comment'?: any;
    /**
     * 担当対象先数
     * @type {number}
     * @memberof EntityAdministrationalSecondaryMemberForLocation
     */
    'numLocations'?: number;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForLocation
     */
    'createdAt'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForLocation
     */
    'updatedAt'?: string;
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntityAdministrationalSecondaryMemberForLocation
     */
    'updatedById'?: number;
    /**
     * 更新者名
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForLocation
     */
    'updatedByName'?: string;
}
/**
 * 
 * @export
 * @interface EntityAdministrationalSecondaryMemberForUpdate
 */
export interface EntityAdministrationalSecondaryMemberForUpdate {
    /**
     * 氏名
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForUpdate
     */
    'name'?: string;
    /**
     * Emailアドレス:string
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForUpdate
     */
    'email2'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForUpdate
     */
    'tel1'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForUpdate
     */
    'tel2'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForUpdate
     */
    'tel3'?: string;
    /**
     * 電話番号/SMS（E.164）
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForUpdate
     */
    'sms'?: string;
    /**
     * 
     * @type {any}
     * @memberof EntityAdministrationalSecondaryMemberForUpdate
     */
    'comment'?: any;
    /**
     * パスワード
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForUpdate
     */
    'password'?: string | null;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForUpdate
     */
    'createdAt'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForUpdate
     */
    'updatedAt'?: string;
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntityAdministrationalSecondaryMemberForUpdate
     */
    'updatedById'?: number;
    /**
     * 更新者名
     * @type {string}
     * @memberof EntityAdministrationalSecondaryMemberForUpdate
     */
    'updatedByName'?: string;
}
/**
 * 
 * @export
 * @interface EntityAdministrationalSecondaryOrganization
 */
export interface EntityAdministrationalSecondaryOrganization {
    /**
     * 組織ID:number
     * @type {number}
     * @memberof EntityAdministrationalSecondaryOrganization
     */
    'organizationId'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof EntityAdministrationalSecondaryOrganization
     */
    'serviceIds'?: Array<number>;
    /**
     * 組織名称
     * @type {string}
     * @memberof EntityAdministrationalSecondaryOrganization
     */
    'name'?: string;
    /**
     * 
     * @type {DomOrganizationType}
     * @memberof EntityAdministrationalSecondaryOrganization
     */
    'type'?: DomOrganizationType;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntityAdministrationalSecondaryOrganization
     */
    'tel'?: string;
    /**
     * 住所
     * @type {string}
     * @memberof EntityAdministrationalSecondaryOrganization
     */
    'address'?: string;
    /**
     * 所属ユーザ数
     * @type {number}
     * @memberof EntityAdministrationalSecondaryOrganization
     */
    'memberNum'?: number;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrationalSecondaryOrganization
     */
    'createdAt'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrationalSecondaryOrganization
     */
    'updatedAt'?: string;
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntityAdministrationalSecondaryOrganization
     */
    'updatedById'?: number;
    /**
     * 更新者名
     * @type {string}
     * @memberof EntityAdministrationalSecondaryOrganization
     */
    'updatedByName'?: string;
    /**
     * 
     * @type {any}
     * @memberof EntityAdministrationalSecondaryOrganization
     */
    'comment'?: any;
}


/**
 * 
 * @export
 * @interface EntityAdministrationalSecondaryOrganizationForCreate
 */
export interface EntityAdministrationalSecondaryOrganizationForCreate {
    /**
     * 組織名称
     * @type {string}
     * @memberof EntityAdministrationalSecondaryOrganizationForCreate
     */
    'name'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntityAdministrationalSecondaryOrganizationForCreate
     */
    'tel'?: string;
    /**
     * 住所
     * @type {string}
     * @memberof EntityAdministrationalSecondaryOrganizationForCreate
     */
    'address'?: string;
    /**
     * 
     * @type {any}
     * @memberof EntityAdministrationalSecondaryOrganizationForCreate
     */
    'comment'?: any;
}
/**
 * 
 * @export
 * @interface EntityAdministrationalSecondaryOrganizationForUpdate
 */
export interface EntityAdministrationalSecondaryOrganizationForUpdate {
    /**
     * 組織名称
     * @type {string}
     * @memberof EntityAdministrationalSecondaryOrganizationForUpdate
     */
    'name'?: string;
    /**
     * 電話番号:string
     * @type {string}
     * @memberof EntityAdministrationalSecondaryOrganizationForUpdate
     */
    'tel'?: string;
    /**
     * 住所
     * @type {string}
     * @memberof EntityAdministrationalSecondaryOrganizationForUpdate
     */
    'address'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrationalSecondaryOrganizationForUpdate
     */
    'createdAt'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrationalSecondaryOrganizationForUpdate
     */
    'updatedAt'?: string;
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntityAdministrationalSecondaryOrganizationForUpdate
     */
    'updatedById'?: number;
    /**
     * 更新者名
     * @type {string}
     * @memberof EntityAdministrationalSecondaryOrganizationForUpdate
     */
    'updatedByName'?: string;
    /**
     * 
     * @type {any}
     * @memberof EntityAdministrationalSecondaryOrganizationForUpdate
     */
    'comment'?: any;
}
/**
 * 
 * @export
 * @interface EntityAdministrator
 */
export interface EntityAdministrator {
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntityAdministrator
     */
    'memberId'?: number;
    /**
     * ユーザ名
     * @type {string}
     * @memberof EntityAdministrator
     */
    'name'?: string;
    /**
     * Emailアドレス:string
     * @type {string}
     * @memberof EntityAdministrator
     */
    'email'?: string;
    /**
     * 管理者種別の名称。実際は管理者用組織の名称。
     * @type {string}
     * @memberof EntityAdministrator
     */
    'type'?: string;
    /**
     * 
     * @type {EntityCapabilities}
     * @memberof EntityAdministrator
     */
    'capabilities'?: EntityCapabilities;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrator
     */
    'createdAt'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministrator
     */
    'updatedAt'?: string;
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntityAdministrator
     */
    'updatedById'?: number;
    /**
     * 更新者名
     * @type {string}
     * @memberof EntityAdministrator
     */
    'updatedByName'?: string;
}
/**
 * 
 * @export
 * @interface EntityAdministratorEditableFieldsForCreate
 */
export interface EntityAdministratorEditableFieldsForCreate {
    /**
     * ユーザ名（氏名）
     * @type {string}
     * @memberof EntityAdministratorEditableFieldsForCreate
     */
    'name'?: string;
    /**
     * ユーザ名（姓）
     * @type {string}
     * @memberof EntityAdministratorEditableFieldsForCreate
     */
    'familyName'?: string;
    /**
     * ユーザ名（名）
     * @type {string}
     * @memberof EntityAdministratorEditableFieldsForCreate
     */
    'givenName'?: string;
    /**
     * Emailアドレス:string
     * @type {string}
     * @memberof EntityAdministratorEditableFieldsForCreate
     */
    'email'?: string;
    /**
     * 組織ID:number
     * @type {number}
     * @memberof EntityAdministratorEditableFieldsForCreate
     */
    'organizationId'?: number;
    /**
     * パスワード
     * @type {string}
     * @memberof EntityAdministratorEditableFieldsForCreate
     */
    'password'?: string | null;
}
/**
 * 
 * @export
 * @interface EntityAdministratorEditableFieldsForUpdate
 */
export interface EntityAdministratorEditableFieldsForUpdate {
    /**
     * ユーザ名（氏名）
     * @type {string}
     * @memberof EntityAdministratorEditableFieldsForUpdate
     */
    'name'?: string;
    /**
     * 組織ID:number
     * @type {number}
     * @memberof EntityAdministratorEditableFieldsForUpdate
     */
    'organizationId'?: number;
    /**
     * パスワード
     * @type {string}
     * @memberof EntityAdministratorEditableFieldsForUpdate
     */
    'password'?: string | null;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministratorEditableFieldsForUpdate
     */
    'createdAt'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof EntityAdministratorEditableFieldsForUpdate
     */
    'updatedAt'?: string;
    /**
     * ユーザID:number
     * @type {number}
     * @memberof EntityAdministratorEditableFieldsForUpdate
     */
    'updatedById'?: number;
    /**
     * 更新者名
     * @type {string}
     * @memberof EntityAdministratorEditableFieldsForUpdate
     */
    'updatedByName'?: string;
}
/**
 * 
 * @export
 * @interface EntityCapabilities
 */
export interface EntityCapabilities {
    /**
     * 操作に対し権限の有無を表す。trueなら操作可能。
     * @type {boolean}
     * @memberof EntityCapabilities
     */
    'capEditService'?: boolean;
    /**
     * 操作に対し権限の有無を表す。trueなら操作可能。
     * @type {boolean}
     * @memberof EntityCapabilities
     */
    'capEditPrimary'?: boolean;
    /**
     * 操作に対し権限の有無を表す。trueなら操作可能。
     * @type {boolean}
     * @memberof EntityCapabilities
     */
    'capEditSecondary'?: boolean;
    /**
     * 操作に対し権限の有無を表す。trueなら操作可能。
     * @type {boolean}
     * @memberof EntityCapabilities
     */
    'capEditLocation'?: boolean;
    /**
     * 操作に対し権限の有無を表す。trueなら操作可能。
     * @type {boolean}
     * @memberof EntityCapabilities
     */
    'capEditAdmin'?: boolean;
    /**
     * 操作に対し権限の有無を表す。trueなら操作可能。
     * @type {boolean}
     * @memberof EntityCapabilities
     */
    'capViewHistory'?: boolean;
}
/**
 * エラーレスポンス
 * @export
 * @interface EntityErrorMsg
 */
export interface EntityErrorMsg {
    /**
     * エラー番号
     * @type {string}
     * @memberof EntityErrorMsg
     */
    'errorNo'?: string;
    /**
     * エラーメッセージ
     * @type {string}
     * @memberof EntityErrorMsg
     */
    'errorMsg'?: string;
}
/**
 * 
 * @export
 * @interface EntityService
 */
export interface EntityService {
    /**
     * サービスID:number
     * @type {number}
     * @memberof EntityService
     */
    'serviceId'?: number;
    /**
     * サービス名称
     * @type {string}
     * @memberof EntityService
     */
    'name'?: string;
    /**
     * 表示順:number
     * @type {number}
     * @memberof EntityService
     */
    'viewOrder'?: number;
    /**
     * 
     * @type {DomEnableFlag}
     * @memberof EntityService
     */
    'isEnabled'?: DomEnableFlag;
}


/**
 * 肯定レスポンス
 * @export
 * @interface EntitySuccessMsg
 */
export interface EntitySuccessMsg {
    /**
     * メッセージ
     * @type {string}
     * @memberof EntitySuccessMsg
     */
    'msg'?: string;
}
/**
 * 
 * @export
 * @interface GetAdministrators200Response
 */
export interface GetAdministrators200Response {
    /**
     * 
     * @type {number}
     * @memberof GetAdministrators200Response
     */
    'total'?: number;
    /**
     * 
     * @type {Array<EntityAdministrator>}
     * @memberof GetAdministrators200Response
     */
    'items'?: Array<EntityAdministrator>;
}
/**
 * 
 * @export
 * @interface GetCollaborators200Response
 */
export interface GetCollaborators200Response {
    /**
     * 総数
     * @type {number}
     * @memberof GetCollaborators200Response
     */
    'total'?: number;
    /**
     * 
     * @type {Array<EntityAdministrationalSecondaryMemberForLocation>}
     * @memberof GetCollaborators200Response
     */
    'items'?: Array<EntityAdministrationalSecondaryMemberForLocation>;
}
/**
 * 
 * @export
 * @interface GetHistoryVideo200Response
 */
export interface GetHistoryVideo200Response {
    /**
     * 
     * @type {string}
     * @memberof GetHistoryVideo200Response
     */
    'url'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof GetHistoryVideo200Response
     */
    'expires'?: string;
}
/**
 * 
 * @export
 * @interface GetLocations200Response
 */
export interface GetLocations200Response {
    /**
     * トータル件数
     * @type {number}
     * @memberof GetLocations200Response
     */
    'total'?: number;
    /**
     * 
     * @type {Array<EntityAdministrationalLocation>}
     * @memberof GetLocations200Response
     */
    'items'?: Array<EntityAdministrationalLocation>;
}
/**
 * 
 * @export
 * @interface GetLocationsRequest
 */
export interface GetLocationsRequest {
    /**
     * サービスID:number
     * @type {number}
     * @memberof GetLocationsRequest
     */
    'serviceId'?: number;
    /**
     * GC番号:string
     * @type {string}
     * @memberof GetLocationsRequest
     */
    'gcNo'?: string;
    /**
     * 号機番号:string
     * @type {string}
     * @memberof GetLocationsRequest
     */
    'gouki'?: string;
    /**
     * 電計番号:string
     * @type {string}
     * @memberof GetLocationsRequest
     */
    'denkei'?: string;
    /**
     * 対象先名称
     * @type {string}
     * @memberof GetLocationsRequest
     */
    'name'?: string | null;
    /**
     * 一ページの最大件数
     * @type {number}
     * @memberof GetLocationsRequest
     */
    'pageMax'?: number;
    /**
     * 指定ページ数
     * @type {number}
     * @memberof GetLocationsRequest
     */
    'pageNum'?: number;
}
/**
 * 
 * @export
 * @interface GetPrimaryOrganizationMembers200Response
 */
export interface GetPrimaryOrganizationMembers200Response {
    /**
     * 総数
     * @type {number}
     * @memberof GetPrimaryOrganizationMembers200Response
     */
    'total'?: number;
    /**
     * 
     * @type {Array<EntityAdministrationalPrimaryMember>}
     * @memberof GetPrimaryOrganizationMembers200Response
     */
    'items'?: Array<EntityAdministrationalPrimaryMember>;
}
/**
 * 
 * @export
 * @interface GetPrimaryOrganizations200Response
 */
export interface GetPrimaryOrganizations200Response {
    /**
     * 総一次専門組織数
     * @type {number}
     * @memberof GetPrimaryOrganizations200Response
     */
    'total'?: number;
    /**
     * 
     * @type {Array<EntityAdministrationalPrimaryOrganization>}
     * @memberof GetPrimaryOrganizations200Response
     */
    'items'?: Array<EntityAdministrationalPrimaryOrganization>;
}
/**
 * 
 * @export
 * @interface GetSecondaryOrganizationMembers200Response
 */
export interface GetSecondaryOrganizationMembers200Response {
    /**
     * 総数
     * @type {number}
     * @memberof GetSecondaryOrganizationMembers200Response
     */
    'total'?: number;
    /**
     * 
     * @type {Array<EntityAdministrationalSecondaryMember>}
     * @memberof GetSecondaryOrganizationMembers200Response
     */
    'items'?: Array<EntityAdministrationalSecondaryMember>;
}
/**
 * 
 * @export
 * @interface GetSummaryRegistrations200Response
 */
export interface GetSummaryRegistrations200Response {
    /**
     * 
     * @type {GetSummaryRegistrations200ResponsePrimary}
     * @memberof GetSummaryRegistrations200Response
     */
    'primary'?: GetSummaryRegistrations200ResponsePrimary;
    /**
     * 
     * @type {GetSummaryRegistrations200ResponseSecondary}
     * @memberof GetSummaryRegistrations200Response
     */
    'secondary'?: GetSummaryRegistrations200ResponseSecondary;
    /**
     * 対象先の登録数
     * @type {number}
     * @memberof GetSummaryRegistrations200Response
     */
    'locations'?: number;
}
/**
 * 一次専門組織の登録数
 * @export
 * @interface GetSummaryRegistrations200ResponsePrimary
 */
export interface GetSummaryRegistrations200ResponsePrimary {
    /**
     * 組織数
     * @type {number}
     * @memberof GetSummaryRegistrations200ResponsePrimary
     */
    'organizations'?: number;
    /**
     * ユーザ数
     * @type {number}
     * @memberof GetSummaryRegistrations200ResponsePrimary
     */
    'members'?: number;
}
/**
 * 二次専門組織の登録数
 * @export
 * @interface GetSummaryRegistrations200ResponseSecondary
 */
export interface GetSummaryRegistrations200ResponseSecondary {
    /**
     * 組織数
     * @type {number}
     * @memberof GetSummaryRegistrations200ResponseSecondary
     */
    'organizations'?: number;
    /**
     * ユーザ数
     * @type {number}
     * @memberof GetSummaryRegistrations200ResponseSecondary
     */
    'members'?: number;
}
/**
 * 
 * @export
 * @interface SearchHistories200Response
 */
export interface SearchHistories200Response {
    /**
     * トータル件数
     * @type {number}
     * @memberof SearchHistories200Response
     */
    'total'?: number;
    /**
     * 
     * @type {Array<EntityAdministrationalHistory>}
     * @memberof SearchHistories200Response
     */
    'items'?: Array<EntityAdministrationalHistory>;
}
/**
 * 
 * @export
 * @interface SearchHistoriesRequest
 */
export interface SearchHistoriesRequest {
    /**
     * サービスID:number
     * @type {number}
     * @memberof SearchHistoriesRequest
     */
    'serviceId'?: number;
    /**
     * GC番号:string
     * @type {string}
     * @memberof SearchHistoriesRequest
     */
    'gcNo'?: string;
    /**
     * 号機番号:string
     * @type {string}
     * @memberof SearchHistoriesRequest
     */
    'gouki'?: string;
    /**
     * 電計番号:string
     * @type {string}
     * @memberof SearchHistoriesRequest
     */
    'denkei'?: string;
    /**
     * 対象先名称
     * @type {string}
     * @memberof SearchHistoriesRequest
     */
    'name'?: string | null;
    /**
     * 隊員番号
     * @type {string}
     * @memberof SearchHistoriesRequest
     */
    'crewNo'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof SearchHistoriesRequest
     */
    'from'?: string;
    /**
     * 日時
     * @type {string}
     * @memberof SearchHistoriesRequest
     */
    'to'?: string;
    /**
     * 一ページの最大件数
     * @type {number}
     * @memberof SearchHistoriesRequest
     */
    'pageMax'?: number;
    /**
     * 指定ページ数
     * @type {number}
     * @memberof SearchHistoriesRequest
     */
    'pageNum'?: number;
}

/**
 * CAPEDITADMINApi - axios parameter creator
 * @export
 */
export const CAPEDITADMINApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 管理者を新規作成する。memberIdは作成時、自動附番。
         * @summary 管理者の新規作成
         * @param {EntityAdministratorEditableFieldsForCreate} entityAdministratorEditableFieldsForCreate 管理者入力情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdministrator: async (entityAdministratorEditableFieldsForCreate: EntityAdministratorEditableFieldsForCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityAdministratorEditableFieldsForCreate' is not null or undefined
            assertParamExists('createAdministrator', 'entityAdministratorEditableFieldsForCreate', entityAdministratorEditableFieldsForCreate)
            const localVarPath = `/member-of-maintainer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityAdministratorEditableFieldsForCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定の管理者を論理削除する。
         * @summary 管理者の論理削除
         * @param {number} memberId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdministrator: async (memberId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('deleteAdministrator', 'memberId', memberId)
            const localVarPath = `/member-of-maintainer/{memberId}`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 管理種別（管理組織）のリストを取得する。
         * @summary 管理種別の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministrationTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/administration-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定の管理者を取得する。
         * @summary 管理者の取得
         * @param {number} memberId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministrator: async (memberId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getAdministrator', 'memberId', memberId)
            const localVarPath = `/member-of-maintainer/{memberId}`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 管理者のリストを取得する。
         * @summary 管理者リストの取得
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministrators: async (pageMax?: number, pageNum?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/member-of-maintainer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageMax !== undefined) {
                localVarQueryParameter['pageMax'] = pageMax;
            }

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定の管理者を更新する。update系のカラムで更新チェックを実施。GET等で取得した値をそのまま渡す。
         * @summary 管理者の更新
         * @param {number} memberId ユーザID
         * @param {EntityAdministratorEditableFieldsForUpdate} entityAdministratorEditableFieldsForUpdate 管理者入力情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdministrator: async (memberId: number, entityAdministratorEditableFieldsForUpdate: EntityAdministratorEditableFieldsForUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('updateAdministrator', 'memberId', memberId)
            // verify required parameter 'entityAdministratorEditableFieldsForUpdate' is not null or undefined
            assertParamExists('updateAdministrator', 'entityAdministratorEditableFieldsForUpdate', entityAdministratorEditableFieldsForUpdate)
            const localVarPath = `/member-of-maintainer/{memberId}`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityAdministratorEditableFieldsForUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CAPEDITADMINApi - functional programming interface
 * @export
 */
export const CAPEDITADMINApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CAPEDITADMINApiAxiosParamCreator(configuration)
    return {
        /**
         * 管理者を新規作成する。memberIdは作成時、自動附番。
         * @summary 管理者の新規作成
         * @param {EntityAdministratorEditableFieldsForCreate} entityAdministratorEditableFieldsForCreate 管理者入力情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAdministrator(entityAdministratorEditableFieldsForCreate: EntityAdministratorEditableFieldsForCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityAdministrator>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAdministrator(entityAdministratorEditableFieldsForCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITADMINApi.createAdministrator']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定の管理者を論理削除する。
         * @summary 管理者の論理削除
         * @param {number} memberId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdministrator(memberId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntitySuccessMsg>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdministrator(memberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITADMINApi.deleteAdministrator']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 管理種別（管理組織）のリストを取得する。
         * @summary 管理種別の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdministrationTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityAdministrationType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdministrationTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITADMINApi.getAdministrationTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定の管理者を取得する。
         * @summary 管理者の取得
         * @param {number} memberId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdministrator(memberId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityAdministrator>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdministrator(memberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITADMINApi.getAdministrator']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 管理者のリストを取得する。
         * @summary 管理者リストの取得
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdministrators(pageMax?: number, pageNum?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdministrators200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdministrators(pageMax, pageNum, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITADMINApi.getAdministrators']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定の管理者を更新する。update系のカラムで更新チェックを実施。GET等で取得した値をそのまま渡す。
         * @summary 管理者の更新
         * @param {number} memberId ユーザID
         * @param {EntityAdministratorEditableFieldsForUpdate} entityAdministratorEditableFieldsForUpdate 管理者入力情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAdministrator(memberId: number, entityAdministratorEditableFieldsForUpdate: EntityAdministratorEditableFieldsForUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityAdministrator>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAdministrator(memberId, entityAdministratorEditableFieldsForUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITADMINApi.updateAdministrator']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CAPEDITADMINApi - factory interface
 * @export
 */
export const CAPEDITADMINApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CAPEDITADMINApiFp(configuration)
    return {
        /**
         * 管理者を新規作成する。memberIdは作成時、自動附番。
         * @summary 管理者の新規作成
         * @param {EntityAdministratorEditableFieldsForCreate} entityAdministratorEditableFieldsForCreate 管理者入力情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdministrator(entityAdministratorEditableFieldsForCreate: EntityAdministratorEditableFieldsForCreate, options?: RawAxiosRequestConfig): AxiosPromise<EntityAdministrator> {
            return localVarFp.createAdministrator(entityAdministratorEditableFieldsForCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定の管理者を論理削除する。
         * @summary 管理者の論理削除
         * @param {number} memberId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdministrator(memberId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntitySuccessMsg>> {
            return localVarFp.deleteAdministrator(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 管理種別（管理組織）のリストを取得する。
         * @summary 管理種別の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministrationTypes(options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityAdministrationType>> {
            return localVarFp.getAdministrationTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 指定の管理者を取得する。
         * @summary 管理者の取得
         * @param {number} memberId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministrator(memberId: number, options?: RawAxiosRequestConfig): AxiosPromise<EntityAdministrator> {
            return localVarFp.getAdministrator(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 管理者のリストを取得する。
         * @summary 管理者リストの取得
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministrators(pageMax?: number, pageNum?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetAdministrators200Response> {
            return localVarFp.getAdministrators(pageMax, pageNum, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定の管理者を更新する。update系のカラムで更新チェックを実施。GET等で取得した値をそのまま渡す。
         * @summary 管理者の更新
         * @param {number} memberId ユーザID
         * @param {EntityAdministratorEditableFieldsForUpdate} entityAdministratorEditableFieldsForUpdate 管理者入力情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdministrator(memberId: number, entityAdministratorEditableFieldsForUpdate: EntityAdministratorEditableFieldsForUpdate, options?: RawAxiosRequestConfig): AxiosPromise<EntityAdministrator> {
            return localVarFp.updateAdministrator(memberId, entityAdministratorEditableFieldsForUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CAPEDITADMINApi - object-oriented interface
 * @export
 * @class CAPEDITADMINApi
 * @extends {BaseAPI}
 */
export class CAPEDITADMINApi extends BaseAPI {
    /**
     * 管理者を新規作成する。memberIdは作成時、自動附番。
     * @summary 管理者の新規作成
     * @param {EntityAdministratorEditableFieldsForCreate} entityAdministratorEditableFieldsForCreate 管理者入力情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITADMINApi
     */
    public createAdministrator(entityAdministratorEditableFieldsForCreate: EntityAdministratorEditableFieldsForCreate, options?: RawAxiosRequestConfig) {
        return CAPEDITADMINApiFp(this.configuration).createAdministrator(entityAdministratorEditableFieldsForCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定の管理者を論理削除する。
     * @summary 管理者の論理削除
     * @param {number} memberId ユーザID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITADMINApi
     */
    public deleteAdministrator(memberId: number, options?: RawAxiosRequestConfig) {
        return CAPEDITADMINApiFp(this.configuration).deleteAdministrator(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 管理種別（管理組織）のリストを取得する。
     * @summary 管理種別の取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITADMINApi
     */
    public getAdministrationTypes(options?: RawAxiosRequestConfig) {
        return CAPEDITADMINApiFp(this.configuration).getAdministrationTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定の管理者を取得する。
     * @summary 管理者の取得
     * @param {number} memberId ユーザID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITADMINApi
     */
    public getAdministrator(memberId: number, options?: RawAxiosRequestConfig) {
        return CAPEDITADMINApiFp(this.configuration).getAdministrator(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 管理者のリストを取得する。
     * @summary 管理者リストの取得
     * @param {number} [pageMax] 1ページの最大件数
     * @param {number} [pageNum] 指定ページ数
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITADMINApi
     */
    public getAdministrators(pageMax?: number, pageNum?: number, options?: RawAxiosRequestConfig) {
        return CAPEDITADMINApiFp(this.configuration).getAdministrators(pageMax, pageNum, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定の管理者を更新する。update系のカラムで更新チェックを実施。GET等で取得した値をそのまま渡す。
     * @summary 管理者の更新
     * @param {number} memberId ユーザID
     * @param {EntityAdministratorEditableFieldsForUpdate} entityAdministratorEditableFieldsForUpdate 管理者入力情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITADMINApi
     */
    public updateAdministrator(memberId: number, entityAdministratorEditableFieldsForUpdate: EntityAdministratorEditableFieldsForUpdate, options?: RawAxiosRequestConfig) {
        return CAPEDITADMINApiFp(this.configuration).updateAdministrator(memberId, entityAdministratorEditableFieldsForUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CAPEDITLOCATIONApi - axios parameter creator
 * @export
 */
export const CAPEDITLOCATIONApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 指定の対象先に登録された二次専門組織のユーザを一括で登録。既存の登録は削除。
         * @summary 関係者（二次専門組織ユーザ）の登録
         * @param {number} serviceId サービスID
         * @param {number} locationId 対象先ID
         * @param {number} organizationId 組織ID
         * @param {Array<number>} requestBody 関係者登録
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollaborators: async (serviceId: number, locationId: number, organizationId: number, requestBody: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('createCollaborators', 'serviceId', serviceId)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('createCollaborators', 'locationId', locationId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createCollaborators', 'organizationId', organizationId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('createCollaborators', 'requestBody', requestBody)
            const localVarPath = `/location/{locationId}/service/{serviceId}/organization/{organizationId}/collaborators`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)))
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 対象先に対する二次専門組織・メンバーの一括登録
         * @param {number} locationId 対象先ID
         * @param {EntityAdministrationalLocationSecondaryOrganizationForCreate} entityAdministrationalLocationSecondaryOrganizationForCreate 関係者登録
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollaboratorsBulk: async (locationId: number, entityAdministrationalLocationSecondaryOrganizationForCreate: EntityAdministrationalLocationSecondaryOrganizationForCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('createCollaboratorsBulk', 'locationId', locationId)
            // verify required parameter 'entityAdministrationalLocationSecondaryOrganizationForCreate' is not null or undefined
            assertParamExists('createCollaboratorsBulk', 'entityAdministrationalLocationSecondaryOrganizationForCreate', entityAdministrationalLocationSecondaryOrganizationForCreate)
            const localVarPath = `/location/{locationId}/secondary-organization`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityAdministrationalLocationSecondaryOrganizationForCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 対象先を新規作成する。
         * @summary 対象先の作成
         * @param {EntityAdministrationalLocationForCreate} entityAdministrationalLocationForCreate 対象先
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocation: async (entityAdministrationalLocationForCreate: EntityAdministrationalLocationForCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityAdministrationalLocationForCreate' is not null or undefined
            assertParamExists('createLocation', 'entityAdministrationalLocationForCreate', entityAdministrationalLocationForCreate)
            const localVarPath = `/location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityAdministrationalLocationForCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 対象先に対する二次専門業者の登録を解除
         * @param {number} locationId 対象先ID
         * @param {number} memberId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCollaborator: async (locationId: number, memberId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('deleteCollaborator', 'locationId', locationId)
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('deleteCollaborator', 'memberId', memberId)
            const localVarPath = `/location/{locationId}/collaborator/{memberId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定の対象先を論理削除する。関連テーブル類も含めて物理削除しない。
         * @summary 対象先の論理削除
         * @param {number} locationId 対象先ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocation: async (locationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('deleteLocation', 'locationId', locationId)
            const localVarPath = `/location/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 関係者（二次専門組織ユーザ）の取得
         * @param {number} locationId 対象先ID
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {string} [userName] ユーザー名（検索用）
         * @param {string} [organizationName] 二次専門組織名（検索用）
         * @param {string} [email] メールアドレス（検索用）
         * @param {number} [serviceId] サービスID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollaborators: async (locationId: number, pageMax?: number, pageNum?: number, userName?: string, organizationName?: string, email?: string, serviceId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getCollaborators', 'locationId', locationId)
            const localVarPath = `/location/{locationId}/collaborators`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageMax !== undefined) {
                localVarQueryParameter['pageMax'] = pageMax;
            }

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (userName !== undefined) {
                localVarQueryParameter['userName'] = userName;
            }

            if (organizationName !== undefined) {
                localVarQueryParameter['organizationName'] = organizationName;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定のサービスに紐づく二次専門組織の一覧を取得する。
         * @summary 対象先の一覧取得
         * @param {GetLocationsRequest} getLocationsRequest 対象先一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocations: async (getLocationsRequest: GetLocationsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getLocationsRequest' is not null or undefined
            assertParamExists('getLocations', 'getLocationsRequest', getLocationsRequest)
            const localVarPath = `/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getLocationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 関係者（二次専門組織ユーザ）の取得
         * @param {number} locationId 対象先ID
         * @param {number} organizationId 組織ID
         * @param {string} [userName] ユーザー名（検索用）
         * @param {string} [email] メールアドレス（検索用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationCollaborators: async (locationId: number, organizationId: number, userName?: string, email?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getOrganizationCollaborators', 'locationId', locationId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationCollaborators', 'organizationId', organizationId)
            const localVarPath = `/location/{locationId}/organization/{organizationId}/collaborators`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userName !== undefined) {
                localVarQueryParameter['userName'] = userName;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定のサービスに紐づく一次専門組織の一覧を取得する。
         * @summary サービスに属する一次専門組織の一覧取得
         * @param {number} serviceId サービスID
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {string} [name] 一次専門組織名（検索用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrimaryOrganizations: async (serviceId: number, pageMax?: number, pageNum?: number, name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('getPrimaryOrganizations', 'serviceId', serviceId)
            const localVarPath = `/service/{serviceId}/primary-organizations`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageMax !== undefined) {
                localVarQueryParameter['pageMax'] = pageMax;
            }

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定の二次専門組織に紐づくユーザの一覧を取得する。
         * @summary 二次専門組ユーザリストの取得
         * @param {number} organizationId 組織ID
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {string} [name] ユーザー名（検索用）
         * @param {string} [email] メールアドレス（検索用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecondaryOrganizationMembers: async (organizationId: number, pageMax?: number, pageNum?: number, name?: string, email?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSecondaryOrganizationMembers', 'organizationId', organizationId)
            const localVarPath = `/secondary-organization/{organizationId}/members`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageMax !== undefined) {
                localVarQueryParameter['pageMax'] = pageMax;
            }

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定のサービスに紐づく二次専門組織の一覧を取得する。
         * @summary サービスに属する二次専門組織の一覧取得
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {string} [name] 二次専門組織名（検索用）
         * @param {number} [serviceId] サービスID
         * @param {string} [address] 住所
         * @param {string} [tel] 電話番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecondaryOrganizations: async (pageMax?: number, pageNum?: number, name?: string, serviceId?: number, address?: string, tel?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/secondary-organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageMax !== undefined) {
                localVarQueryParameter['pageMax'] = pageMax;
            }

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }

            if (address !== undefined) {
                localVarQueryParameter['address'] = address;
            }

            if (tel !== undefined) {
                localVarQueryParameter['tel'] = tel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 登録されているサービスの一覧を取得する。
         * @summary サービス一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServices: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定の対象先を更新更新する。update系のカラムで更新チェックを実施。GET等で取得した値をそのまま渡す。
         * @summary 対象先の更新
         * @param {number} locationId 対象先ID
         * @param {EntityAdministrationalLocationForUpdate} entityAdministrationalLocationForUpdate 対象先
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocation: async (locationId: number, entityAdministrationalLocationForUpdate: EntityAdministrationalLocationForUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('updateLocation', 'locationId', locationId)
            // verify required parameter 'entityAdministrationalLocationForUpdate' is not null or undefined
            assertParamExists('updateLocation', 'entityAdministrationalLocationForUpdate', entityAdministrationalLocationForUpdate)
            const localVarPath = `/location/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityAdministrationalLocationForUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CAPEDITLOCATIONApi - functional programming interface
 * @export
 */
export const CAPEDITLOCATIONApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CAPEDITLOCATIONApiAxiosParamCreator(configuration)
    return {
        /**
         * 指定の対象先に登録された二次専門組織のユーザを一括で登録。既存の登録は削除。
         * @summary 関係者（二次専門組織ユーザ）の登録
         * @param {number} serviceId サービスID
         * @param {number} locationId 対象先ID
         * @param {number} organizationId 組織ID
         * @param {Array<number>} requestBody 関係者登録
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCollaborators(serviceId: number, locationId: number, organizationId: number, requestBody: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntitySuccessMsg>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCollaborators(serviceId, locationId, organizationId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITLOCATIONApi.createCollaborators']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 対象先に対する二次専門組織・メンバーの一括登録
         * @param {number} locationId 対象先ID
         * @param {EntityAdministrationalLocationSecondaryOrganizationForCreate} entityAdministrationalLocationSecondaryOrganizationForCreate 関係者登録
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCollaboratorsBulk(locationId: number, entityAdministrationalLocationSecondaryOrganizationForCreate: EntityAdministrationalLocationSecondaryOrganizationForCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntitySuccessMsg>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCollaboratorsBulk(locationId, entityAdministrationalLocationSecondaryOrganizationForCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITLOCATIONApi.createCollaboratorsBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 対象先を新規作成する。
         * @summary 対象先の作成
         * @param {EntityAdministrationalLocationForCreate} entityAdministrationalLocationForCreate 対象先
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLocation(entityAdministrationalLocationForCreate: EntityAdministrationalLocationForCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityAdministrationalLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLocation(entityAdministrationalLocationForCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITLOCATIONApi.createLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 対象先に対する二次専門業者の登録を解除
         * @param {number} locationId 対象先ID
         * @param {number} memberId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCollaborator(locationId: number, memberId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntitySuccessMsg>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCollaborator(locationId, memberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITLOCATIONApi.deleteCollaborator']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定の対象先を論理削除する。関連テーブル類も含めて物理削除しない。
         * @summary 対象先の論理削除
         * @param {number} locationId 対象先ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLocation(locationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntitySuccessMsg>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLocation(locationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITLOCATIONApi.deleteLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 関係者（二次専門組織ユーザ）の取得
         * @param {number} locationId 対象先ID
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {string} [userName] ユーザー名（検索用）
         * @param {string} [organizationName] 二次専門組織名（検索用）
         * @param {string} [email] メールアドレス（検索用）
         * @param {number} [serviceId] サービスID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollaborators(locationId: number, pageMax?: number, pageNum?: number, userName?: string, organizationName?: string, email?: string, serviceId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCollaborators200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollaborators(locationId, pageMax, pageNum, userName, organizationName, email, serviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITLOCATIONApi.getCollaborators']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定のサービスに紐づく二次専門組織の一覧を取得する。
         * @summary 対象先の一覧取得
         * @param {GetLocationsRequest} getLocationsRequest 対象先一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocations(getLocationsRequest: GetLocationsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLocations200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocations(getLocationsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITLOCATIONApi.getLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 関係者（二次専門組織ユーザ）の取得
         * @param {number} locationId 対象先ID
         * @param {number} organizationId 組織ID
         * @param {string} [userName] ユーザー名（検索用）
         * @param {string} [email] メールアドレス（検索用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationCollaborators(locationId: number, organizationId: number, userName?: string, email?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCollaborators200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationCollaborators(locationId, organizationId, userName, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITLOCATIONApi.getOrganizationCollaborators']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定のサービスに紐づく一次専門組織の一覧を取得する。
         * @summary サービスに属する一次専門組織の一覧取得
         * @param {number} serviceId サービスID
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {string} [name] 一次専門組織名（検索用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrimaryOrganizations(serviceId: number, pageMax?: number, pageNum?: number, name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPrimaryOrganizations200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrimaryOrganizations(serviceId, pageMax, pageNum, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITLOCATIONApi.getPrimaryOrganizations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定の二次専門組織に紐づくユーザの一覧を取得する。
         * @summary 二次専門組ユーザリストの取得
         * @param {number} organizationId 組織ID
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {string} [name] ユーザー名（検索用）
         * @param {string} [email] メールアドレス（検索用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSecondaryOrganizationMembers(organizationId: number, pageMax?: number, pageNum?: number, name?: string, email?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSecondaryOrganizationMembers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSecondaryOrganizationMembers(organizationId, pageMax, pageNum, name, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITLOCATIONApi.getSecondaryOrganizationMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定のサービスに紐づく二次専門組織の一覧を取得する。
         * @summary サービスに属する二次専門組織の一覧取得
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {string} [name] 二次専門組織名（検索用）
         * @param {number} [serviceId] サービスID
         * @param {string} [address] 住所
         * @param {string} [tel] 電話番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSecondaryOrganizations(pageMax?: number, pageNum?: number, name?: string, serviceId?: number, address?: string, tel?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityAdministrationalSecondaryOrganization>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSecondaryOrganizations(pageMax, pageNum, name, serviceId, address, tel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITLOCATIONApi.getSecondaryOrganizations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 登録されているサービスの一覧を取得する。
         * @summary サービス一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServices(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityService>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServices(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITLOCATIONApi.getServices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定の対象先を更新更新する。update系のカラムで更新チェックを実施。GET等で取得した値をそのまま渡す。
         * @summary 対象先の更新
         * @param {number} locationId 対象先ID
         * @param {EntityAdministrationalLocationForUpdate} entityAdministrationalLocationForUpdate 対象先
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLocation(locationId: number, entityAdministrationalLocationForUpdate: EntityAdministrationalLocationForUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityAdministrationalLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLocation(locationId, entityAdministrationalLocationForUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITLOCATIONApi.updateLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CAPEDITLOCATIONApi - factory interface
 * @export
 */
export const CAPEDITLOCATIONApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CAPEDITLOCATIONApiFp(configuration)
    return {
        /**
         * 指定の対象先に登録された二次専門組織のユーザを一括で登録。既存の登録は削除。
         * @summary 関係者（二次専門組織ユーザ）の登録
         * @param {number} serviceId サービスID
         * @param {number} locationId 対象先ID
         * @param {number} organizationId 組織ID
         * @param {Array<number>} requestBody 関係者登録
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollaborators(serviceId: number, locationId: number, organizationId: number, requestBody: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntitySuccessMsg>> {
            return localVarFp.createCollaborators(serviceId, locationId, organizationId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 対象先に対する二次専門組織・メンバーの一括登録
         * @param {number} locationId 対象先ID
         * @param {EntityAdministrationalLocationSecondaryOrganizationForCreate} entityAdministrationalLocationSecondaryOrganizationForCreate 関係者登録
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollaboratorsBulk(locationId: number, entityAdministrationalLocationSecondaryOrganizationForCreate: EntityAdministrationalLocationSecondaryOrganizationForCreate, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntitySuccessMsg>> {
            return localVarFp.createCollaboratorsBulk(locationId, entityAdministrationalLocationSecondaryOrganizationForCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 対象先を新規作成する。
         * @summary 対象先の作成
         * @param {EntityAdministrationalLocationForCreate} entityAdministrationalLocationForCreate 対象先
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocation(entityAdministrationalLocationForCreate: EntityAdministrationalLocationForCreate, options?: RawAxiosRequestConfig): AxiosPromise<EntityAdministrationalLocation> {
            return localVarFp.createLocation(entityAdministrationalLocationForCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 対象先に対する二次専門業者の登録を解除
         * @param {number} locationId 対象先ID
         * @param {number} memberId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCollaborator(locationId: number, memberId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntitySuccessMsg>> {
            return localVarFp.deleteCollaborator(locationId, memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定の対象先を論理削除する。関連テーブル類も含めて物理削除しない。
         * @summary 対象先の論理削除
         * @param {number} locationId 対象先ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocation(locationId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntitySuccessMsg>> {
            return localVarFp.deleteLocation(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 関係者（二次専門組織ユーザ）の取得
         * @param {number} locationId 対象先ID
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {string} [userName] ユーザー名（検索用）
         * @param {string} [organizationName] 二次専門組織名（検索用）
         * @param {string} [email] メールアドレス（検索用）
         * @param {number} [serviceId] サービスID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollaborators(locationId: number, pageMax?: number, pageNum?: number, userName?: string, organizationName?: string, email?: string, serviceId?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetCollaborators200Response> {
            return localVarFp.getCollaborators(locationId, pageMax, pageNum, userName, organizationName, email, serviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定のサービスに紐づく二次専門組織の一覧を取得する。
         * @summary 対象先の一覧取得
         * @param {GetLocationsRequest} getLocationsRequest 対象先一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocations(getLocationsRequest: GetLocationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetLocations200Response> {
            return localVarFp.getLocations(getLocationsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 関係者（二次専門組織ユーザ）の取得
         * @param {number} locationId 対象先ID
         * @param {number} organizationId 組織ID
         * @param {string} [userName] ユーザー名（検索用）
         * @param {string} [email] メールアドレス（検索用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationCollaborators(locationId: number, organizationId: number, userName?: string, email?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetCollaborators200Response> {
            return localVarFp.getOrganizationCollaborators(locationId, organizationId, userName, email, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定のサービスに紐づく一次専門組織の一覧を取得する。
         * @summary サービスに属する一次専門組織の一覧取得
         * @param {number} serviceId サービスID
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {string} [name] 一次専門組織名（検索用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrimaryOrganizations(serviceId: number, pageMax?: number, pageNum?: number, name?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetPrimaryOrganizations200Response> {
            return localVarFp.getPrimaryOrganizations(serviceId, pageMax, pageNum, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定の二次専門組織に紐づくユーザの一覧を取得する。
         * @summary 二次専門組ユーザリストの取得
         * @param {number} organizationId 組織ID
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {string} [name] ユーザー名（検索用）
         * @param {string} [email] メールアドレス（検索用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecondaryOrganizationMembers(organizationId: number, pageMax?: number, pageNum?: number, name?: string, email?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetSecondaryOrganizationMembers200Response> {
            return localVarFp.getSecondaryOrganizationMembers(organizationId, pageMax, pageNum, name, email, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定のサービスに紐づく二次専門組織の一覧を取得する。
         * @summary サービスに属する二次専門組織の一覧取得
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {string} [name] 二次専門組織名（検索用）
         * @param {number} [serviceId] サービスID
         * @param {string} [address] 住所
         * @param {string} [tel] 電話番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecondaryOrganizations(pageMax?: number, pageNum?: number, name?: string, serviceId?: number, address?: string, tel?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityAdministrationalSecondaryOrganization>> {
            return localVarFp.getSecondaryOrganizations(pageMax, pageNum, name, serviceId, address, tel, options).then((request) => request(axios, basePath));
        },
        /**
         * 登録されているサービスの一覧を取得する。
         * @summary サービス一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServices(options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityService>> {
            return localVarFp.getServices(options).then((request) => request(axios, basePath));
        },
        /**
         * 指定の対象先を更新更新する。update系のカラムで更新チェックを実施。GET等で取得した値をそのまま渡す。
         * @summary 対象先の更新
         * @param {number} locationId 対象先ID
         * @param {EntityAdministrationalLocationForUpdate} entityAdministrationalLocationForUpdate 対象先
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocation(locationId: number, entityAdministrationalLocationForUpdate: EntityAdministrationalLocationForUpdate, options?: RawAxiosRequestConfig): AxiosPromise<EntityAdministrationalLocation> {
            return localVarFp.updateLocation(locationId, entityAdministrationalLocationForUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CAPEDITLOCATIONApi - object-oriented interface
 * @export
 * @class CAPEDITLOCATIONApi
 * @extends {BaseAPI}
 */
export class CAPEDITLOCATIONApi extends BaseAPI {
    /**
     * 指定の対象先に登録された二次専門組織のユーザを一括で登録。既存の登録は削除。
     * @summary 関係者（二次専門組織ユーザ）の登録
     * @param {number} serviceId サービスID
     * @param {number} locationId 対象先ID
     * @param {number} organizationId 組織ID
     * @param {Array<number>} requestBody 関係者登録
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITLOCATIONApi
     */
    public createCollaborators(serviceId: number, locationId: number, organizationId: number, requestBody: Array<number>, options?: RawAxiosRequestConfig) {
        return CAPEDITLOCATIONApiFp(this.configuration).createCollaborators(serviceId, locationId, organizationId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 対象先に対する二次専門組織・メンバーの一括登録
     * @param {number} locationId 対象先ID
     * @param {EntityAdministrationalLocationSecondaryOrganizationForCreate} entityAdministrationalLocationSecondaryOrganizationForCreate 関係者登録
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITLOCATIONApi
     */
    public createCollaboratorsBulk(locationId: number, entityAdministrationalLocationSecondaryOrganizationForCreate: EntityAdministrationalLocationSecondaryOrganizationForCreate, options?: RawAxiosRequestConfig) {
        return CAPEDITLOCATIONApiFp(this.configuration).createCollaboratorsBulk(locationId, entityAdministrationalLocationSecondaryOrganizationForCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 対象先を新規作成する。
     * @summary 対象先の作成
     * @param {EntityAdministrationalLocationForCreate} entityAdministrationalLocationForCreate 対象先
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITLOCATIONApi
     */
    public createLocation(entityAdministrationalLocationForCreate: EntityAdministrationalLocationForCreate, options?: RawAxiosRequestConfig) {
        return CAPEDITLOCATIONApiFp(this.configuration).createLocation(entityAdministrationalLocationForCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 対象先に対する二次専門業者の登録を解除
     * @param {number} locationId 対象先ID
     * @param {number} memberId ユーザID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITLOCATIONApi
     */
    public deleteCollaborator(locationId: number, memberId: number, options?: RawAxiosRequestConfig) {
        return CAPEDITLOCATIONApiFp(this.configuration).deleteCollaborator(locationId, memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定の対象先を論理削除する。関連テーブル類も含めて物理削除しない。
     * @summary 対象先の論理削除
     * @param {number} locationId 対象先ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITLOCATIONApi
     */
    public deleteLocation(locationId: number, options?: RawAxiosRequestConfig) {
        return CAPEDITLOCATIONApiFp(this.configuration).deleteLocation(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 関係者（二次専門組織ユーザ）の取得
     * @param {number} locationId 対象先ID
     * @param {number} [pageMax] 1ページの最大件数
     * @param {number} [pageNum] 指定ページ数
     * @param {string} [userName] ユーザー名（検索用）
     * @param {string} [organizationName] 二次専門組織名（検索用）
     * @param {string} [email] メールアドレス（検索用）
     * @param {number} [serviceId] サービスID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITLOCATIONApi
     */
    public getCollaborators(locationId: number, pageMax?: number, pageNum?: number, userName?: string, organizationName?: string, email?: string, serviceId?: number, options?: RawAxiosRequestConfig) {
        return CAPEDITLOCATIONApiFp(this.configuration).getCollaborators(locationId, pageMax, pageNum, userName, organizationName, email, serviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定のサービスに紐づく二次専門組織の一覧を取得する。
     * @summary 対象先の一覧取得
     * @param {GetLocationsRequest} getLocationsRequest 対象先一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITLOCATIONApi
     */
    public getLocations(getLocationsRequest: GetLocationsRequest, options?: RawAxiosRequestConfig) {
        return CAPEDITLOCATIONApiFp(this.configuration).getLocations(getLocationsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 関係者（二次専門組織ユーザ）の取得
     * @param {number} locationId 対象先ID
     * @param {number} organizationId 組織ID
     * @param {string} [userName] ユーザー名（検索用）
     * @param {string} [email] メールアドレス（検索用）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITLOCATIONApi
     */
    public getOrganizationCollaborators(locationId: number, organizationId: number, userName?: string, email?: string, options?: RawAxiosRequestConfig) {
        return CAPEDITLOCATIONApiFp(this.configuration).getOrganizationCollaborators(locationId, organizationId, userName, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定のサービスに紐づく一次専門組織の一覧を取得する。
     * @summary サービスに属する一次専門組織の一覧取得
     * @param {number} serviceId サービスID
     * @param {number} [pageMax] 1ページの最大件数
     * @param {number} [pageNum] 指定ページ数
     * @param {string} [name] 一次専門組織名（検索用）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITLOCATIONApi
     */
    public getPrimaryOrganizations(serviceId: number, pageMax?: number, pageNum?: number, name?: string, options?: RawAxiosRequestConfig) {
        return CAPEDITLOCATIONApiFp(this.configuration).getPrimaryOrganizations(serviceId, pageMax, pageNum, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定の二次専門組織に紐づくユーザの一覧を取得する。
     * @summary 二次専門組ユーザリストの取得
     * @param {number} organizationId 組織ID
     * @param {number} [pageMax] 1ページの最大件数
     * @param {number} [pageNum] 指定ページ数
     * @param {string} [name] ユーザー名（検索用）
     * @param {string} [email] メールアドレス（検索用）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITLOCATIONApi
     */
    public getSecondaryOrganizationMembers(organizationId: number, pageMax?: number, pageNum?: number, name?: string, email?: string, options?: RawAxiosRequestConfig) {
        return CAPEDITLOCATIONApiFp(this.configuration).getSecondaryOrganizationMembers(organizationId, pageMax, pageNum, name, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定のサービスに紐づく二次専門組織の一覧を取得する。
     * @summary サービスに属する二次専門組織の一覧取得
     * @param {number} [pageMax] 1ページの最大件数
     * @param {number} [pageNum] 指定ページ数
     * @param {string} [name] 二次専門組織名（検索用）
     * @param {number} [serviceId] サービスID
     * @param {string} [address] 住所
     * @param {string} [tel] 電話番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITLOCATIONApi
     */
    public getSecondaryOrganizations(pageMax?: number, pageNum?: number, name?: string, serviceId?: number, address?: string, tel?: string, options?: RawAxiosRequestConfig) {
        return CAPEDITLOCATIONApiFp(this.configuration).getSecondaryOrganizations(pageMax, pageNum, name, serviceId, address, tel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 登録されているサービスの一覧を取得する。
     * @summary サービス一覧の取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITLOCATIONApi
     */
    public getServices(options?: RawAxiosRequestConfig) {
        return CAPEDITLOCATIONApiFp(this.configuration).getServices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定の対象先を更新更新する。update系のカラムで更新チェックを実施。GET等で取得した値をそのまま渡す。
     * @summary 対象先の更新
     * @param {number} locationId 対象先ID
     * @param {EntityAdministrationalLocationForUpdate} entityAdministrationalLocationForUpdate 対象先
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITLOCATIONApi
     */
    public updateLocation(locationId: number, entityAdministrationalLocationForUpdate: EntityAdministrationalLocationForUpdate, options?: RawAxiosRequestConfig) {
        return CAPEDITLOCATIONApiFp(this.configuration).updateLocation(locationId, entityAdministrationalLocationForUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CAPEDITPRIMARYApi - axios parameter creator
 * @export
 */
export const CAPEDITPRIMARYApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 一次専門組織を新規作成する。
         * @summary 一次専門組織の作成
         * @param {EntityAdministrationalPrimaryOrganizationForCreate} entityAdministrationalPrimaryOrganizationForCreate 一次専門組織
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPrimaryOrganization: async (entityAdministrationalPrimaryOrganizationForCreate: EntityAdministrationalPrimaryOrganizationForCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityAdministrationalPrimaryOrganizationForCreate' is not null or undefined
            assertParamExists('createPrimaryOrganization', 'entityAdministrationalPrimaryOrganizationForCreate', entityAdministrationalPrimaryOrganizationForCreate)
            const localVarPath = `/primary-organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityAdministrationalPrimaryOrganizationForCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 一次専門組織ユーザの新規作成
         * @summary 一次専門組織ユーザ作成
         * @param {number} organizationId 組織ID
         * @param {EntityAdministrationalPrimaryMemberForCreate} entityAdministrationalPrimaryMemberForCreate 一次専門組織ユーザ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPrimaryOrganizationMember: async (organizationId: number, entityAdministrationalPrimaryMemberForCreate: EntityAdministrationalPrimaryMemberForCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createPrimaryOrganizationMember', 'organizationId', organizationId)
            // verify required parameter 'entityAdministrationalPrimaryMemberForCreate' is not null or undefined
            assertParamExists('createPrimaryOrganizationMember', 'entityAdministrationalPrimaryMemberForCreate', entityAdministrationalPrimaryMemberForCreate)
            const localVarPath = `/primary-organization/{organizationId}/member`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityAdministrationalPrimaryMemberForCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定の一次専門組織を論理削除する。関連テーブル類も含めて物理削除しない。
         * @summary 一次専門組織の論理削除
         * @param {number} organizationId 組織ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePrimaryOrganization: async (organizationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deletePrimaryOrganization', 'organizationId', organizationId)
            const localVarPath = `/primary-organization/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定の一次専門組織ユーザを論理削除する。
         * @summary 一次専門組織ユーザの論理削除
         * @param {number} organizationId 組織ID
         * @param {number} memberId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePrimaryOrganizationMember: async (organizationId: number, memberId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deletePrimaryOrganizationMember', 'organizationId', organizationId)
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('deletePrimaryOrganizationMember', 'memberId', memberId)
            const localVarPath = `/primary-organization/{organizationId}/member/{memberId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定の一次専門組織に紐づくユーザの一覧を取得する。
         * @summary 一次専門組ユーザリストの取得
         * @param {number} organizationId 組織ID
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {string} [name] ユーザー名（検索用）
         * @param {string} [email] メールアドレス（検索用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrimaryOrganizationMembers: async (organizationId: number, pageMax?: number, pageNum?: number, name?: string, email?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getPrimaryOrganizationMembers', 'organizationId', organizationId)
            const localVarPath = `/primary-organization/{organizationId}/members`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageMax !== undefined) {
                localVarQueryParameter['pageMax'] = pageMax;
            }

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定のサービスに紐づく一次専門組織の一覧を取得する。
         * @summary サービスに属する一次専門組織の一覧取得
         * @param {number} serviceId サービスID
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {string} [name] 一次専門組織名（検索用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrimaryOrganizations: async (serviceId: number, pageMax?: number, pageNum?: number, name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('getPrimaryOrganizations', 'serviceId', serviceId)
            const localVarPath = `/service/{serviceId}/primary-organizations`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageMax !== undefined) {
                localVarQueryParameter['pageMax'] = pageMax;
            }

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 登録されているサービスの一覧を取得する。
         * @summary サービス一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServices: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定の一次専門組織を更新更新する。update系のカラムで更新チェックを実施。GET等で取得した値をそのまま渡す。
         * @summary 一次専門組織の更新
         * @param {number} organizationId 組織ID
         * @param {EntityAdministrationalPrimaryOrganizationForUpdate} entityAdministrationalPrimaryOrganizationForUpdate 一次専門組織
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrimaryOrganization: async (organizationId: number, entityAdministrationalPrimaryOrganizationForUpdate: EntityAdministrationalPrimaryOrganizationForUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updatePrimaryOrganization', 'organizationId', organizationId)
            // verify required parameter 'entityAdministrationalPrimaryOrganizationForUpdate' is not null or undefined
            assertParamExists('updatePrimaryOrganization', 'entityAdministrationalPrimaryOrganizationForUpdate', entityAdministrationalPrimaryOrganizationForUpdate)
            const localVarPath = `/primary-organization/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityAdministrationalPrimaryOrganizationForUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定の一次専門組織ユーザを更新する。update系のカラムで更新チェックを実施。GET等で取得した値をそのまま渡す。
         * @summary 一次専門組織ユーザの更新
         * @param {number} organizationId 組織ID
         * @param {number} memberId ユーザID
         * @param {EntityAdministrationalPrimaryMemberForUpdate} entityAdministrationalPrimaryMemberForUpdate 一次専門組織ユーザ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrimaryOrganizationMember: async (organizationId: number, memberId: number, entityAdministrationalPrimaryMemberForUpdate: EntityAdministrationalPrimaryMemberForUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updatePrimaryOrganizationMember', 'organizationId', organizationId)
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('updatePrimaryOrganizationMember', 'memberId', memberId)
            // verify required parameter 'entityAdministrationalPrimaryMemberForUpdate' is not null or undefined
            assertParamExists('updatePrimaryOrganizationMember', 'entityAdministrationalPrimaryMemberForUpdate', entityAdministrationalPrimaryMemberForUpdate)
            const localVarPath = `/primary-organization/{organizationId}/member/{memberId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityAdministrationalPrimaryMemberForUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CAPEDITPRIMARYApi - functional programming interface
 * @export
 */
export const CAPEDITPRIMARYApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CAPEDITPRIMARYApiAxiosParamCreator(configuration)
    return {
        /**
         * 一次専門組織を新規作成する。
         * @summary 一次専門組織の作成
         * @param {EntityAdministrationalPrimaryOrganizationForCreate} entityAdministrationalPrimaryOrganizationForCreate 一次専門組織
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPrimaryOrganization(entityAdministrationalPrimaryOrganizationForCreate: EntityAdministrationalPrimaryOrganizationForCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityAdministrationalPrimaryOrganization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPrimaryOrganization(entityAdministrationalPrimaryOrganizationForCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITPRIMARYApi.createPrimaryOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 一次専門組織ユーザの新規作成
         * @summary 一次専門組織ユーザ作成
         * @param {number} organizationId 組織ID
         * @param {EntityAdministrationalPrimaryMemberForCreate} entityAdministrationalPrimaryMemberForCreate 一次専門組織ユーザ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPrimaryOrganizationMember(organizationId: number, entityAdministrationalPrimaryMemberForCreate: EntityAdministrationalPrimaryMemberForCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityAdministrationalPrimaryMember>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPrimaryOrganizationMember(organizationId, entityAdministrationalPrimaryMemberForCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITPRIMARYApi.createPrimaryOrganizationMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定の一次専門組織を論理削除する。関連テーブル類も含めて物理削除しない。
         * @summary 一次専門組織の論理削除
         * @param {number} organizationId 組織ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePrimaryOrganization(organizationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntitySuccessMsg>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePrimaryOrganization(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITPRIMARYApi.deletePrimaryOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定の一次専門組織ユーザを論理削除する。
         * @summary 一次専門組織ユーザの論理削除
         * @param {number} organizationId 組織ID
         * @param {number} memberId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePrimaryOrganizationMember(organizationId: number, memberId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntitySuccessMsg>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePrimaryOrganizationMember(organizationId, memberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITPRIMARYApi.deletePrimaryOrganizationMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定の一次専門組織に紐づくユーザの一覧を取得する。
         * @summary 一次専門組ユーザリストの取得
         * @param {number} organizationId 組織ID
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {string} [name] ユーザー名（検索用）
         * @param {string} [email] メールアドレス（検索用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrimaryOrganizationMembers(organizationId: number, pageMax?: number, pageNum?: number, name?: string, email?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPrimaryOrganizationMembers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrimaryOrganizationMembers(organizationId, pageMax, pageNum, name, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITPRIMARYApi.getPrimaryOrganizationMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定のサービスに紐づく一次専門組織の一覧を取得する。
         * @summary サービスに属する一次専門組織の一覧取得
         * @param {number} serviceId サービスID
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {string} [name] 一次専門組織名（検索用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrimaryOrganizations(serviceId: number, pageMax?: number, pageNum?: number, name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPrimaryOrganizations200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrimaryOrganizations(serviceId, pageMax, pageNum, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITPRIMARYApi.getPrimaryOrganizations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 登録されているサービスの一覧を取得する。
         * @summary サービス一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServices(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityService>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServices(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITPRIMARYApi.getServices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定の一次専門組織を更新更新する。update系のカラムで更新チェックを実施。GET等で取得した値をそのまま渡す。
         * @summary 一次専門組織の更新
         * @param {number} organizationId 組織ID
         * @param {EntityAdministrationalPrimaryOrganizationForUpdate} entityAdministrationalPrimaryOrganizationForUpdate 一次専門組織
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePrimaryOrganization(organizationId: number, entityAdministrationalPrimaryOrganizationForUpdate: EntityAdministrationalPrimaryOrganizationForUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityAdministrationalPrimaryOrganization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePrimaryOrganization(organizationId, entityAdministrationalPrimaryOrganizationForUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITPRIMARYApi.updatePrimaryOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定の一次専門組織ユーザを更新する。update系のカラムで更新チェックを実施。GET等で取得した値をそのまま渡す。
         * @summary 一次専門組織ユーザの更新
         * @param {number} organizationId 組織ID
         * @param {number} memberId ユーザID
         * @param {EntityAdministrationalPrimaryMemberForUpdate} entityAdministrationalPrimaryMemberForUpdate 一次専門組織ユーザ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePrimaryOrganizationMember(organizationId: number, memberId: number, entityAdministrationalPrimaryMemberForUpdate: EntityAdministrationalPrimaryMemberForUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityAdministrationalPrimaryMember>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePrimaryOrganizationMember(organizationId, memberId, entityAdministrationalPrimaryMemberForUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITPRIMARYApi.updatePrimaryOrganizationMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CAPEDITPRIMARYApi - factory interface
 * @export
 */
export const CAPEDITPRIMARYApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CAPEDITPRIMARYApiFp(configuration)
    return {
        /**
         * 一次専門組織を新規作成する。
         * @summary 一次専門組織の作成
         * @param {EntityAdministrationalPrimaryOrganizationForCreate} entityAdministrationalPrimaryOrganizationForCreate 一次専門組織
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPrimaryOrganization(entityAdministrationalPrimaryOrganizationForCreate: EntityAdministrationalPrimaryOrganizationForCreate, options?: RawAxiosRequestConfig): AxiosPromise<EntityAdministrationalPrimaryOrganization> {
            return localVarFp.createPrimaryOrganization(entityAdministrationalPrimaryOrganizationForCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 一次専門組織ユーザの新規作成
         * @summary 一次専門組織ユーザ作成
         * @param {number} organizationId 組織ID
         * @param {EntityAdministrationalPrimaryMemberForCreate} entityAdministrationalPrimaryMemberForCreate 一次専門組織ユーザ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPrimaryOrganizationMember(organizationId: number, entityAdministrationalPrimaryMemberForCreate: EntityAdministrationalPrimaryMemberForCreate, options?: RawAxiosRequestConfig): AxiosPromise<EntityAdministrationalPrimaryMember> {
            return localVarFp.createPrimaryOrganizationMember(organizationId, entityAdministrationalPrimaryMemberForCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定の一次専門組織を論理削除する。関連テーブル類も含めて物理削除しない。
         * @summary 一次専門組織の論理削除
         * @param {number} organizationId 組織ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePrimaryOrganization(organizationId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntitySuccessMsg>> {
            return localVarFp.deletePrimaryOrganization(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定の一次専門組織ユーザを論理削除する。
         * @summary 一次専門組織ユーザの論理削除
         * @param {number} organizationId 組織ID
         * @param {number} memberId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePrimaryOrganizationMember(organizationId: number, memberId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntitySuccessMsg>> {
            return localVarFp.deletePrimaryOrganizationMember(organizationId, memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定の一次専門組織に紐づくユーザの一覧を取得する。
         * @summary 一次専門組ユーザリストの取得
         * @param {number} organizationId 組織ID
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {string} [name] ユーザー名（検索用）
         * @param {string} [email] メールアドレス（検索用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrimaryOrganizationMembers(organizationId: number, pageMax?: number, pageNum?: number, name?: string, email?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetPrimaryOrganizationMembers200Response> {
            return localVarFp.getPrimaryOrganizationMembers(organizationId, pageMax, pageNum, name, email, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定のサービスに紐づく一次専門組織の一覧を取得する。
         * @summary サービスに属する一次専門組織の一覧取得
         * @param {number} serviceId サービスID
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {string} [name] 一次専門組織名（検索用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrimaryOrganizations(serviceId: number, pageMax?: number, pageNum?: number, name?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetPrimaryOrganizations200Response> {
            return localVarFp.getPrimaryOrganizations(serviceId, pageMax, pageNum, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 登録されているサービスの一覧を取得する。
         * @summary サービス一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServices(options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityService>> {
            return localVarFp.getServices(options).then((request) => request(axios, basePath));
        },
        /**
         * 指定の一次専門組織を更新更新する。update系のカラムで更新チェックを実施。GET等で取得した値をそのまま渡す。
         * @summary 一次専門組織の更新
         * @param {number} organizationId 組織ID
         * @param {EntityAdministrationalPrimaryOrganizationForUpdate} entityAdministrationalPrimaryOrganizationForUpdate 一次専門組織
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrimaryOrganization(organizationId: number, entityAdministrationalPrimaryOrganizationForUpdate: EntityAdministrationalPrimaryOrganizationForUpdate, options?: RawAxiosRequestConfig): AxiosPromise<EntityAdministrationalPrimaryOrganization> {
            return localVarFp.updatePrimaryOrganization(organizationId, entityAdministrationalPrimaryOrganizationForUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定の一次専門組織ユーザを更新する。update系のカラムで更新チェックを実施。GET等で取得した値をそのまま渡す。
         * @summary 一次専門組織ユーザの更新
         * @param {number} organizationId 組織ID
         * @param {number} memberId ユーザID
         * @param {EntityAdministrationalPrimaryMemberForUpdate} entityAdministrationalPrimaryMemberForUpdate 一次専門組織ユーザ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrimaryOrganizationMember(organizationId: number, memberId: number, entityAdministrationalPrimaryMemberForUpdate: EntityAdministrationalPrimaryMemberForUpdate, options?: RawAxiosRequestConfig): AxiosPromise<EntityAdministrationalPrimaryMember> {
            return localVarFp.updatePrimaryOrganizationMember(organizationId, memberId, entityAdministrationalPrimaryMemberForUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CAPEDITPRIMARYApi - object-oriented interface
 * @export
 * @class CAPEDITPRIMARYApi
 * @extends {BaseAPI}
 */
export class CAPEDITPRIMARYApi extends BaseAPI {
    /**
     * 一次専門組織を新規作成する。
     * @summary 一次専門組織の作成
     * @param {EntityAdministrationalPrimaryOrganizationForCreate} entityAdministrationalPrimaryOrganizationForCreate 一次専門組織
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITPRIMARYApi
     */
    public createPrimaryOrganization(entityAdministrationalPrimaryOrganizationForCreate: EntityAdministrationalPrimaryOrganizationForCreate, options?: RawAxiosRequestConfig) {
        return CAPEDITPRIMARYApiFp(this.configuration).createPrimaryOrganization(entityAdministrationalPrimaryOrganizationForCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 一次専門組織ユーザの新規作成
     * @summary 一次専門組織ユーザ作成
     * @param {number} organizationId 組織ID
     * @param {EntityAdministrationalPrimaryMemberForCreate} entityAdministrationalPrimaryMemberForCreate 一次専門組織ユーザ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITPRIMARYApi
     */
    public createPrimaryOrganizationMember(organizationId: number, entityAdministrationalPrimaryMemberForCreate: EntityAdministrationalPrimaryMemberForCreate, options?: RawAxiosRequestConfig) {
        return CAPEDITPRIMARYApiFp(this.configuration).createPrimaryOrganizationMember(organizationId, entityAdministrationalPrimaryMemberForCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定の一次専門組織を論理削除する。関連テーブル類も含めて物理削除しない。
     * @summary 一次専門組織の論理削除
     * @param {number} organizationId 組織ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITPRIMARYApi
     */
    public deletePrimaryOrganization(organizationId: number, options?: RawAxiosRequestConfig) {
        return CAPEDITPRIMARYApiFp(this.configuration).deletePrimaryOrganization(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定の一次専門組織ユーザを論理削除する。
     * @summary 一次専門組織ユーザの論理削除
     * @param {number} organizationId 組織ID
     * @param {number} memberId ユーザID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITPRIMARYApi
     */
    public deletePrimaryOrganizationMember(organizationId: number, memberId: number, options?: RawAxiosRequestConfig) {
        return CAPEDITPRIMARYApiFp(this.configuration).deletePrimaryOrganizationMember(organizationId, memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定の一次専門組織に紐づくユーザの一覧を取得する。
     * @summary 一次専門組ユーザリストの取得
     * @param {number} organizationId 組織ID
     * @param {number} [pageMax] 1ページの最大件数
     * @param {number} [pageNum] 指定ページ数
     * @param {string} [name] ユーザー名（検索用）
     * @param {string} [email] メールアドレス（検索用）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITPRIMARYApi
     */
    public getPrimaryOrganizationMembers(organizationId: number, pageMax?: number, pageNum?: number, name?: string, email?: string, options?: RawAxiosRequestConfig) {
        return CAPEDITPRIMARYApiFp(this.configuration).getPrimaryOrganizationMembers(organizationId, pageMax, pageNum, name, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定のサービスに紐づく一次専門組織の一覧を取得する。
     * @summary サービスに属する一次専門組織の一覧取得
     * @param {number} serviceId サービスID
     * @param {number} [pageMax] 1ページの最大件数
     * @param {number} [pageNum] 指定ページ数
     * @param {string} [name] 一次専門組織名（検索用）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITPRIMARYApi
     */
    public getPrimaryOrganizations(serviceId: number, pageMax?: number, pageNum?: number, name?: string, options?: RawAxiosRequestConfig) {
        return CAPEDITPRIMARYApiFp(this.configuration).getPrimaryOrganizations(serviceId, pageMax, pageNum, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 登録されているサービスの一覧を取得する。
     * @summary サービス一覧の取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITPRIMARYApi
     */
    public getServices(options?: RawAxiosRequestConfig) {
        return CAPEDITPRIMARYApiFp(this.configuration).getServices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定の一次専門組織を更新更新する。update系のカラムで更新チェックを実施。GET等で取得した値をそのまま渡す。
     * @summary 一次専門組織の更新
     * @param {number} organizationId 組織ID
     * @param {EntityAdministrationalPrimaryOrganizationForUpdate} entityAdministrationalPrimaryOrganizationForUpdate 一次専門組織
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITPRIMARYApi
     */
    public updatePrimaryOrganization(organizationId: number, entityAdministrationalPrimaryOrganizationForUpdate: EntityAdministrationalPrimaryOrganizationForUpdate, options?: RawAxiosRequestConfig) {
        return CAPEDITPRIMARYApiFp(this.configuration).updatePrimaryOrganization(organizationId, entityAdministrationalPrimaryOrganizationForUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定の一次専門組織ユーザを更新する。update系のカラムで更新チェックを実施。GET等で取得した値をそのまま渡す。
     * @summary 一次専門組織ユーザの更新
     * @param {number} organizationId 組織ID
     * @param {number} memberId ユーザID
     * @param {EntityAdministrationalPrimaryMemberForUpdate} entityAdministrationalPrimaryMemberForUpdate 一次専門組織ユーザ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITPRIMARYApi
     */
    public updatePrimaryOrganizationMember(organizationId: number, memberId: number, entityAdministrationalPrimaryMemberForUpdate: EntityAdministrationalPrimaryMemberForUpdate, options?: RawAxiosRequestConfig) {
        return CAPEDITPRIMARYApiFp(this.configuration).updatePrimaryOrganizationMember(organizationId, memberId, entityAdministrationalPrimaryMemberForUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CAPEDITSECONDARYApi - axios parameter creator
 * @export
 */
export const CAPEDITSECONDARYApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 二次専門組織を新規作成する。
         * @summary 二次専門組織の作成
         * @param {EntityAdministrationalSecondaryOrganizationForCreate} entityAdministrationalSecondaryOrganizationForCreate 二次専門組織
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSecondaryOrganization: async (entityAdministrationalSecondaryOrganizationForCreate: EntityAdministrationalSecondaryOrganizationForCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityAdministrationalSecondaryOrganizationForCreate' is not null or undefined
            assertParamExists('createSecondaryOrganization', 'entityAdministrationalSecondaryOrganizationForCreate', entityAdministrationalSecondaryOrganizationForCreate)
            const localVarPath = `/secondary-organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityAdministrationalSecondaryOrganizationForCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 二次専門組織ユーザの新規作成
         * @summary 二次専門組織ユーザ作成
         * @param {number} organizationId 組織ID
         * @param {EntityAdministrationalSecondaryMemberForCreate} entityAdministrationalSecondaryMemberForCreate 二次専門組織ユーザ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSecondaryOrganizationMember: async (organizationId: number, entityAdministrationalSecondaryMemberForCreate: EntityAdministrationalSecondaryMemberForCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createSecondaryOrganizationMember', 'organizationId', organizationId)
            // verify required parameter 'entityAdministrationalSecondaryMemberForCreate' is not null or undefined
            assertParamExists('createSecondaryOrganizationMember', 'entityAdministrationalSecondaryMemberForCreate', entityAdministrationalSecondaryMemberForCreate)
            const localVarPath = `/secondary-organization/{organizationId}/member`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityAdministrationalSecondaryMemberForCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定の二次専門組織を論理削除する。関連テーブル類も含めて物理削除しない。
         * @summary 二次専門組織の論理削除
         * @param {number} organizationId 組織ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSecondaryOrganization: async (organizationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteSecondaryOrganization', 'organizationId', organizationId)
            const localVarPath = `/secondary-organization/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定の二次専門組織ユーザを論理削除する。
         * @summary 二次専門組織ユーザの論理削除
         * @param {number} organizationId 組織ID
         * @param {number} memberId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSecondaryOrganizationMember: async (organizationId: number, memberId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteSecondaryOrganizationMember', 'organizationId', organizationId)
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('deleteSecondaryOrganizationMember', 'memberId', memberId)
            const localVarPath = `/secondary-organization/{organizationId}/member/{memberId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定の二次専門組織に紐づくユーザの一覧を取得する。
         * @summary 二次専門組ユーザリストの取得
         * @param {number} organizationId 組織ID
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {string} [name] ユーザー名（検索用）
         * @param {string} [email] メールアドレス（検索用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecondaryOrganizationMembers: async (organizationId: number, pageMax?: number, pageNum?: number, name?: string, email?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getSecondaryOrganizationMembers', 'organizationId', organizationId)
            const localVarPath = `/secondary-organization/{organizationId}/members`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageMax !== undefined) {
                localVarQueryParameter['pageMax'] = pageMax;
            }

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定のサービスに紐づく二次専門組織の一覧を取得する。
         * @summary サービスに属する二次専門組織の一覧取得
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {string} [name] 二次専門組織名（検索用）
         * @param {number} [serviceId] サービスID
         * @param {string} [address] 住所
         * @param {string} [tel] 電話番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecondaryOrganizations: async (pageMax?: number, pageNum?: number, name?: string, serviceId?: number, address?: string, tel?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/secondary-organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageMax !== undefined) {
                localVarQueryParameter['pageMax'] = pageMax;
            }

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }

            if (address !== undefined) {
                localVarQueryParameter['address'] = address;
            }

            if (tel !== undefined) {
                localVarQueryParameter['tel'] = tel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 登録されているサービスの一覧を取得する。
         * @summary サービス一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServices: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定の二次専門組織を更新更新する。update系のカラムで更新チェックを実施。GET等で取得した値をそのまま渡す。
         * @summary 二次専門組織の更新
         * @param {number} organizationId 組織ID
         * @param {EntityAdministrationalSecondaryOrganizationForUpdate} entityAdministrationalSecondaryOrganizationForUpdate 二次専門組織
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSecondaryOrganization: async (organizationId: number, entityAdministrationalSecondaryOrganizationForUpdate: EntityAdministrationalSecondaryOrganizationForUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateSecondaryOrganization', 'organizationId', organizationId)
            // verify required parameter 'entityAdministrationalSecondaryOrganizationForUpdate' is not null or undefined
            assertParamExists('updateSecondaryOrganization', 'entityAdministrationalSecondaryOrganizationForUpdate', entityAdministrationalSecondaryOrganizationForUpdate)
            const localVarPath = `/secondary-organization/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityAdministrationalSecondaryOrganizationForUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定の二次専門組織ユーザを更新する。update系のカラムで更新チェックを実施。GET等で取得した値をそのまま渡す。
         * @summary 二次専門組織ユーザの更新
         * @param {number} organizationId 組織ID
         * @param {number} memberId ユーザID
         * @param {EntityAdministrationalSecondaryMemberForUpdate} entityAdministrationalSecondaryMemberForUpdate 二次専門組織ユーザ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSecondaryOrganizationMember: async (organizationId: number, memberId: number, entityAdministrationalSecondaryMemberForUpdate: EntityAdministrationalSecondaryMemberForUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateSecondaryOrganizationMember', 'organizationId', organizationId)
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('updateSecondaryOrganizationMember', 'memberId', memberId)
            // verify required parameter 'entityAdministrationalSecondaryMemberForUpdate' is not null or undefined
            assertParamExists('updateSecondaryOrganizationMember', 'entityAdministrationalSecondaryMemberForUpdate', entityAdministrationalSecondaryMemberForUpdate)
            const localVarPath = `/secondary-organization/{organizationId}/member/{memberId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entityAdministrationalSecondaryMemberForUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CAPEDITSECONDARYApi - functional programming interface
 * @export
 */
export const CAPEDITSECONDARYApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CAPEDITSECONDARYApiAxiosParamCreator(configuration)
    return {
        /**
         * 二次専門組織を新規作成する。
         * @summary 二次専門組織の作成
         * @param {EntityAdministrationalSecondaryOrganizationForCreate} entityAdministrationalSecondaryOrganizationForCreate 二次専門組織
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSecondaryOrganization(entityAdministrationalSecondaryOrganizationForCreate: EntityAdministrationalSecondaryOrganizationForCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityAdministrationalSecondaryOrganization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSecondaryOrganization(entityAdministrationalSecondaryOrganizationForCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITSECONDARYApi.createSecondaryOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 二次専門組織ユーザの新規作成
         * @summary 二次専門組織ユーザ作成
         * @param {number} organizationId 組織ID
         * @param {EntityAdministrationalSecondaryMemberForCreate} entityAdministrationalSecondaryMemberForCreate 二次専門組織ユーザ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSecondaryOrganizationMember(organizationId: number, entityAdministrationalSecondaryMemberForCreate: EntityAdministrationalSecondaryMemberForCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityAdministrationalSecondaryMember>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSecondaryOrganizationMember(organizationId, entityAdministrationalSecondaryMemberForCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITSECONDARYApi.createSecondaryOrganizationMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定の二次専門組織を論理削除する。関連テーブル類も含めて物理削除しない。
         * @summary 二次専門組織の論理削除
         * @param {number} organizationId 組織ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSecondaryOrganization(organizationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntitySuccessMsg>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSecondaryOrganization(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITSECONDARYApi.deleteSecondaryOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定の二次専門組織ユーザを論理削除する。
         * @summary 二次専門組織ユーザの論理削除
         * @param {number} organizationId 組織ID
         * @param {number} memberId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSecondaryOrganizationMember(organizationId: number, memberId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntitySuccessMsg>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSecondaryOrganizationMember(organizationId, memberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITSECONDARYApi.deleteSecondaryOrganizationMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定の二次専門組織に紐づくユーザの一覧を取得する。
         * @summary 二次専門組ユーザリストの取得
         * @param {number} organizationId 組織ID
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {string} [name] ユーザー名（検索用）
         * @param {string} [email] メールアドレス（検索用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSecondaryOrganizationMembers(organizationId: number, pageMax?: number, pageNum?: number, name?: string, email?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSecondaryOrganizationMembers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSecondaryOrganizationMembers(organizationId, pageMax, pageNum, name, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITSECONDARYApi.getSecondaryOrganizationMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定のサービスに紐づく二次専門組織の一覧を取得する。
         * @summary サービスに属する二次専門組織の一覧取得
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {string} [name] 二次専門組織名（検索用）
         * @param {number} [serviceId] サービスID
         * @param {string} [address] 住所
         * @param {string} [tel] 電話番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSecondaryOrganizations(pageMax?: number, pageNum?: number, name?: string, serviceId?: number, address?: string, tel?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityAdministrationalSecondaryOrganization>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSecondaryOrganizations(pageMax, pageNum, name, serviceId, address, tel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITSECONDARYApi.getSecondaryOrganizations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 登録されているサービスの一覧を取得する。
         * @summary サービス一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServices(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityService>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServices(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITSECONDARYApi.getServices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定の二次専門組織を更新更新する。update系のカラムで更新チェックを実施。GET等で取得した値をそのまま渡す。
         * @summary 二次専門組織の更新
         * @param {number} organizationId 組織ID
         * @param {EntityAdministrationalSecondaryOrganizationForUpdate} entityAdministrationalSecondaryOrganizationForUpdate 二次専門組織
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSecondaryOrganization(organizationId: number, entityAdministrationalSecondaryOrganizationForUpdate: EntityAdministrationalSecondaryOrganizationForUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityAdministrationalSecondaryOrganization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSecondaryOrganization(organizationId, entityAdministrationalSecondaryOrganizationForUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITSECONDARYApi.updateSecondaryOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定の二次専門組織ユーザを更新する。update系のカラムで更新チェックを実施。GET等で取得した値をそのまま渡す。
         * @summary 二次専門組織ユーザの更新
         * @param {number} organizationId 組織ID
         * @param {number} memberId ユーザID
         * @param {EntityAdministrationalSecondaryMemberForUpdate} entityAdministrationalSecondaryMemberForUpdate 二次専門組織ユーザ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSecondaryOrganizationMember(organizationId: number, memberId: number, entityAdministrationalSecondaryMemberForUpdate: EntityAdministrationalSecondaryMemberForUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityAdministrationalSecondaryMember>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSecondaryOrganizationMember(organizationId, memberId, entityAdministrationalSecondaryMemberForUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITSECONDARYApi.updateSecondaryOrganizationMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CAPEDITSECONDARYApi - factory interface
 * @export
 */
export const CAPEDITSECONDARYApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CAPEDITSECONDARYApiFp(configuration)
    return {
        /**
         * 二次専門組織を新規作成する。
         * @summary 二次専門組織の作成
         * @param {EntityAdministrationalSecondaryOrganizationForCreate} entityAdministrationalSecondaryOrganizationForCreate 二次専門組織
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSecondaryOrganization(entityAdministrationalSecondaryOrganizationForCreate: EntityAdministrationalSecondaryOrganizationForCreate, options?: RawAxiosRequestConfig): AxiosPromise<EntityAdministrationalSecondaryOrganization> {
            return localVarFp.createSecondaryOrganization(entityAdministrationalSecondaryOrganizationForCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 二次専門組織ユーザの新規作成
         * @summary 二次専門組織ユーザ作成
         * @param {number} organizationId 組織ID
         * @param {EntityAdministrationalSecondaryMemberForCreate} entityAdministrationalSecondaryMemberForCreate 二次専門組織ユーザ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSecondaryOrganizationMember(organizationId: number, entityAdministrationalSecondaryMemberForCreate: EntityAdministrationalSecondaryMemberForCreate, options?: RawAxiosRequestConfig): AxiosPromise<EntityAdministrationalSecondaryMember> {
            return localVarFp.createSecondaryOrganizationMember(organizationId, entityAdministrationalSecondaryMemberForCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定の二次専門組織を論理削除する。関連テーブル類も含めて物理削除しない。
         * @summary 二次専門組織の論理削除
         * @param {number} organizationId 組織ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSecondaryOrganization(organizationId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntitySuccessMsg>> {
            return localVarFp.deleteSecondaryOrganization(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定の二次専門組織ユーザを論理削除する。
         * @summary 二次専門組織ユーザの論理削除
         * @param {number} organizationId 組織ID
         * @param {number} memberId ユーザID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSecondaryOrganizationMember(organizationId: number, memberId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntitySuccessMsg>> {
            return localVarFp.deleteSecondaryOrganizationMember(organizationId, memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定の二次専門組織に紐づくユーザの一覧を取得する。
         * @summary 二次専門組ユーザリストの取得
         * @param {number} organizationId 組織ID
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {string} [name] ユーザー名（検索用）
         * @param {string} [email] メールアドレス（検索用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecondaryOrganizationMembers(organizationId: number, pageMax?: number, pageNum?: number, name?: string, email?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetSecondaryOrganizationMembers200Response> {
            return localVarFp.getSecondaryOrganizationMembers(organizationId, pageMax, pageNum, name, email, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定のサービスに紐づく二次専門組織の一覧を取得する。
         * @summary サービスに属する二次専門組織の一覧取得
         * @param {number} [pageMax] 1ページの最大件数
         * @param {number} [pageNum] 指定ページ数
         * @param {string} [name] 二次専門組織名（検索用）
         * @param {number} [serviceId] サービスID
         * @param {string} [address] 住所
         * @param {string} [tel] 電話番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecondaryOrganizations(pageMax?: number, pageNum?: number, name?: string, serviceId?: number, address?: string, tel?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityAdministrationalSecondaryOrganization>> {
            return localVarFp.getSecondaryOrganizations(pageMax, pageNum, name, serviceId, address, tel, options).then((request) => request(axios, basePath));
        },
        /**
         * 登録されているサービスの一覧を取得する。
         * @summary サービス一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServices(options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityService>> {
            return localVarFp.getServices(options).then((request) => request(axios, basePath));
        },
        /**
         * 指定の二次専門組織を更新更新する。update系のカラムで更新チェックを実施。GET等で取得した値をそのまま渡す。
         * @summary 二次専門組織の更新
         * @param {number} organizationId 組織ID
         * @param {EntityAdministrationalSecondaryOrganizationForUpdate} entityAdministrationalSecondaryOrganizationForUpdate 二次専門組織
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSecondaryOrganization(organizationId: number, entityAdministrationalSecondaryOrganizationForUpdate: EntityAdministrationalSecondaryOrganizationForUpdate, options?: RawAxiosRequestConfig): AxiosPromise<EntityAdministrationalSecondaryOrganization> {
            return localVarFp.updateSecondaryOrganization(organizationId, entityAdministrationalSecondaryOrganizationForUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定の二次専門組織ユーザを更新する。update系のカラムで更新チェックを実施。GET等で取得した値をそのまま渡す。
         * @summary 二次専門組織ユーザの更新
         * @param {number} organizationId 組織ID
         * @param {number} memberId ユーザID
         * @param {EntityAdministrationalSecondaryMemberForUpdate} entityAdministrationalSecondaryMemberForUpdate 二次専門組織ユーザ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSecondaryOrganizationMember(organizationId: number, memberId: number, entityAdministrationalSecondaryMemberForUpdate: EntityAdministrationalSecondaryMemberForUpdate, options?: RawAxiosRequestConfig): AxiosPromise<EntityAdministrationalSecondaryMember> {
            return localVarFp.updateSecondaryOrganizationMember(organizationId, memberId, entityAdministrationalSecondaryMemberForUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CAPEDITSECONDARYApi - object-oriented interface
 * @export
 * @class CAPEDITSECONDARYApi
 * @extends {BaseAPI}
 */
export class CAPEDITSECONDARYApi extends BaseAPI {
    /**
     * 二次専門組織を新規作成する。
     * @summary 二次専門組織の作成
     * @param {EntityAdministrationalSecondaryOrganizationForCreate} entityAdministrationalSecondaryOrganizationForCreate 二次専門組織
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITSECONDARYApi
     */
    public createSecondaryOrganization(entityAdministrationalSecondaryOrganizationForCreate: EntityAdministrationalSecondaryOrganizationForCreate, options?: RawAxiosRequestConfig) {
        return CAPEDITSECONDARYApiFp(this.configuration).createSecondaryOrganization(entityAdministrationalSecondaryOrganizationForCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 二次専門組織ユーザの新規作成
     * @summary 二次専門組織ユーザ作成
     * @param {number} organizationId 組織ID
     * @param {EntityAdministrationalSecondaryMemberForCreate} entityAdministrationalSecondaryMemberForCreate 二次専門組織ユーザ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITSECONDARYApi
     */
    public createSecondaryOrganizationMember(organizationId: number, entityAdministrationalSecondaryMemberForCreate: EntityAdministrationalSecondaryMemberForCreate, options?: RawAxiosRequestConfig) {
        return CAPEDITSECONDARYApiFp(this.configuration).createSecondaryOrganizationMember(organizationId, entityAdministrationalSecondaryMemberForCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定の二次専門組織を論理削除する。関連テーブル類も含めて物理削除しない。
     * @summary 二次専門組織の論理削除
     * @param {number} organizationId 組織ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITSECONDARYApi
     */
    public deleteSecondaryOrganization(organizationId: number, options?: RawAxiosRequestConfig) {
        return CAPEDITSECONDARYApiFp(this.configuration).deleteSecondaryOrganization(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定の二次専門組織ユーザを論理削除する。
     * @summary 二次専門組織ユーザの論理削除
     * @param {number} organizationId 組織ID
     * @param {number} memberId ユーザID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITSECONDARYApi
     */
    public deleteSecondaryOrganizationMember(organizationId: number, memberId: number, options?: RawAxiosRequestConfig) {
        return CAPEDITSECONDARYApiFp(this.configuration).deleteSecondaryOrganizationMember(organizationId, memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定の二次専門組織に紐づくユーザの一覧を取得する。
     * @summary 二次専門組ユーザリストの取得
     * @param {number} organizationId 組織ID
     * @param {number} [pageMax] 1ページの最大件数
     * @param {number} [pageNum] 指定ページ数
     * @param {string} [name] ユーザー名（検索用）
     * @param {string} [email] メールアドレス（検索用）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITSECONDARYApi
     */
    public getSecondaryOrganizationMembers(organizationId: number, pageMax?: number, pageNum?: number, name?: string, email?: string, options?: RawAxiosRequestConfig) {
        return CAPEDITSECONDARYApiFp(this.configuration).getSecondaryOrganizationMembers(organizationId, pageMax, pageNum, name, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定のサービスに紐づく二次専門組織の一覧を取得する。
     * @summary サービスに属する二次専門組織の一覧取得
     * @param {number} [pageMax] 1ページの最大件数
     * @param {number} [pageNum] 指定ページ数
     * @param {string} [name] 二次専門組織名（検索用）
     * @param {number} [serviceId] サービスID
     * @param {string} [address] 住所
     * @param {string} [tel] 電話番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITSECONDARYApi
     */
    public getSecondaryOrganizations(pageMax?: number, pageNum?: number, name?: string, serviceId?: number, address?: string, tel?: string, options?: RawAxiosRequestConfig) {
        return CAPEDITSECONDARYApiFp(this.configuration).getSecondaryOrganizations(pageMax, pageNum, name, serviceId, address, tel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 登録されているサービスの一覧を取得する。
     * @summary サービス一覧の取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITSECONDARYApi
     */
    public getServices(options?: RawAxiosRequestConfig) {
        return CAPEDITSECONDARYApiFp(this.configuration).getServices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定の二次専門組織を更新更新する。update系のカラムで更新チェックを実施。GET等で取得した値をそのまま渡す。
     * @summary 二次専門組織の更新
     * @param {number} organizationId 組織ID
     * @param {EntityAdministrationalSecondaryOrganizationForUpdate} entityAdministrationalSecondaryOrganizationForUpdate 二次専門組織
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITSECONDARYApi
     */
    public updateSecondaryOrganization(organizationId: number, entityAdministrationalSecondaryOrganizationForUpdate: EntityAdministrationalSecondaryOrganizationForUpdate, options?: RawAxiosRequestConfig) {
        return CAPEDITSECONDARYApiFp(this.configuration).updateSecondaryOrganization(organizationId, entityAdministrationalSecondaryOrganizationForUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定の二次専門組織ユーザを更新する。update系のカラムで更新チェックを実施。GET等で取得した値をそのまま渡す。
     * @summary 二次専門組織ユーザの更新
     * @param {number} organizationId 組織ID
     * @param {number} memberId ユーザID
     * @param {EntityAdministrationalSecondaryMemberForUpdate} entityAdministrationalSecondaryMemberForUpdate 二次専門組織ユーザ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITSECONDARYApi
     */
    public updateSecondaryOrganizationMember(organizationId: number, memberId: number, entityAdministrationalSecondaryMemberForUpdate: EntityAdministrationalSecondaryMemberForUpdate, options?: RawAxiosRequestConfig) {
        return CAPEDITSECONDARYApiFp(this.configuration).updateSecondaryOrganizationMember(organizationId, memberId, entityAdministrationalSecondaryMemberForUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CAPEDITSERVICEApi - axios parameter creator
 * @export
 */
export const CAPEDITSERVICEApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 登録されているサービスの一覧を取得する。
         * @summary サービス一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServices: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CAPEDITSERVICEApi - functional programming interface
 * @export
 */
export const CAPEDITSERVICEApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CAPEDITSERVICEApiAxiosParamCreator(configuration)
    return {
        /**
         * 登録されているサービスの一覧を取得する。
         * @summary サービス一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServices(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityService>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServices(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPEDITSERVICEApi.getServices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CAPEDITSERVICEApi - factory interface
 * @export
 */
export const CAPEDITSERVICEApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CAPEDITSERVICEApiFp(configuration)
    return {
        /**
         * 登録されているサービスの一覧を取得する。
         * @summary サービス一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServices(options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityService>> {
            return localVarFp.getServices(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CAPEDITSERVICEApi - object-oriented interface
 * @export
 * @class CAPEDITSERVICEApi
 * @extends {BaseAPI}
 */
export class CAPEDITSERVICEApi extends BaseAPI {
    /**
     * 登録されているサービスの一覧を取得する。
     * @summary サービス一覧の取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPEDITSERVICEApi
     */
    public getServices(options?: RawAxiosRequestConfig) {
        return CAPEDITSERVICEApiFp(this.configuration).getServices(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CAPVIEWHISTORYApi - axios parameter creator
 * @export
 */
export const CAPVIEWHISTORYApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 検索条件にしたがって、履歴をCSVでダウンロードする
         * @summary 履歴検索結果のCSVダウンロード
         * @param {DownloadHistoriesCsvRequest} downloadHistoriesCsvRequest 履歴検索条件
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadHistoriesCsv: async (downloadHistoriesCsvRequest: DownloadHistoriesCsvRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'downloadHistoriesCsvRequest' is not null or undefined
            assertParamExists('downloadHistoriesCsv', 'downloadHistoriesCsvRequest', downloadHistoriesCsvRequest)
            const localVarPath = `/histories/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadHistoriesCsvRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定の履歴の録画像アクセス用URLの取得
         * @summary 指定の履歴の録画像アクセス用URLの取得
         * @param {string} meetingId 会議ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryVideo: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getHistoryVideo', 'meetingId', meetingId)
            const localVarPath = `/history/{meetingId}/video`
                .replace(`{${"meetingId"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 登録されているサービスの一覧を取得する。
         * @summary サービス一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServices: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 検索条件にしたがって、履歴を検索する。
         * @summary 履歴検索
         * @param {SearchHistoriesRequest} searchHistoriesRequest 履歴検索条件
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchHistories: async (searchHistoriesRequest: SearchHistoriesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchHistoriesRequest' is not null or undefined
            assertParamExists('searchHistories', 'searchHistoriesRequest', searchHistoriesRequest)
            const localVarPath = `/histories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchHistoriesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CAPVIEWHISTORYApi - functional programming interface
 * @export
 */
export const CAPVIEWHISTORYApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CAPVIEWHISTORYApiAxiosParamCreator(configuration)
    return {
        /**
         * 検索条件にしたがって、履歴をCSVでダウンロードする
         * @summary 履歴検索結果のCSVダウンロード
         * @param {DownloadHistoriesCsvRequest} downloadHistoriesCsvRequest 履歴検索条件
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadHistoriesCsv(downloadHistoriesCsvRequest: DownloadHistoriesCsvRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadHistoriesCsv(downloadHistoriesCsvRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPVIEWHISTORYApi.downloadHistoriesCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 指定の履歴の録画像アクセス用URLの取得
         * @summary 指定の履歴の録画像アクセス用URLの取得
         * @param {string} meetingId 会議ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHistoryVideo(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetHistoryVideo200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHistoryVideo(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPVIEWHISTORYApi.getHistoryVideo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 登録されているサービスの一覧を取得する。
         * @summary サービス一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServices(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityService>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServices(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPVIEWHISTORYApi.getServices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 検索条件にしたがって、履歴を検索する。
         * @summary 履歴検索
         * @param {SearchHistoriesRequest} searchHistoriesRequest 履歴検索条件
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchHistories(searchHistoriesRequest: SearchHistoriesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchHistories200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchHistories(searchHistoriesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAPVIEWHISTORYApi.searchHistories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CAPVIEWHISTORYApi - factory interface
 * @export
 */
export const CAPVIEWHISTORYApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CAPVIEWHISTORYApiFp(configuration)
    return {
        /**
         * 検索条件にしたがって、履歴をCSVでダウンロードする
         * @summary 履歴検索結果のCSVダウンロード
         * @param {DownloadHistoriesCsvRequest} downloadHistoriesCsvRequest 履歴検索条件
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadHistoriesCsv(downloadHistoriesCsvRequest: DownloadHistoriesCsvRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.downloadHistoriesCsv(downloadHistoriesCsvRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定の履歴の録画像アクセス用URLの取得
         * @summary 指定の履歴の録画像アクセス用URLの取得
         * @param {string} meetingId 会議ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryVideo(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetHistoryVideo200Response> {
            return localVarFp.getHistoryVideo(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 登録されているサービスの一覧を取得する。
         * @summary サービス一覧の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServices(options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityService>> {
            return localVarFp.getServices(options).then((request) => request(axios, basePath));
        },
        /**
         * 検索条件にしたがって、履歴を検索する。
         * @summary 履歴検索
         * @param {SearchHistoriesRequest} searchHistoriesRequest 履歴検索条件
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchHistories(searchHistoriesRequest: SearchHistoriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SearchHistories200Response> {
            return localVarFp.searchHistories(searchHistoriesRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CAPVIEWHISTORYApi - object-oriented interface
 * @export
 * @class CAPVIEWHISTORYApi
 * @extends {BaseAPI}
 */
export class CAPVIEWHISTORYApi extends BaseAPI {
    /**
     * 検索条件にしたがって、履歴をCSVでダウンロードする
     * @summary 履歴検索結果のCSVダウンロード
     * @param {DownloadHistoriesCsvRequest} downloadHistoriesCsvRequest 履歴検索条件
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPVIEWHISTORYApi
     */
    public downloadHistoriesCsv(downloadHistoriesCsvRequest: DownloadHistoriesCsvRequest, options?: RawAxiosRequestConfig) {
        return CAPVIEWHISTORYApiFp(this.configuration).downloadHistoriesCsv(downloadHistoriesCsvRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定の履歴の録画像アクセス用URLの取得
     * @summary 指定の履歴の録画像アクセス用URLの取得
     * @param {string} meetingId 会議ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPVIEWHISTORYApi
     */
    public getHistoryVideo(meetingId: string, options?: RawAxiosRequestConfig) {
        return CAPVIEWHISTORYApiFp(this.configuration).getHistoryVideo(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 登録されているサービスの一覧を取得する。
     * @summary サービス一覧の取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPVIEWHISTORYApi
     */
    public getServices(options?: RawAxiosRequestConfig) {
        return CAPVIEWHISTORYApiFp(this.configuration).getServices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 検索条件にしたがって、履歴を検索する。
     * @summary 履歴検索
     * @param {SearchHistoriesRequest} searchHistoriesRequest 履歴検索条件
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAPVIEWHISTORYApi
     */
    public searchHistories(searchHistoriesRequest: SearchHistoriesRequest, options?: RawAxiosRequestConfig) {
        return CAPVIEWHISTORYApiFp(this.configuration).searchHistories(searchHistoriesRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NOCAPApi - axios parameter creator
 * @export
 */
export const NOCAPApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 各種登録数の取得（ダッシュボード用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryRegistrations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/summary/registrations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * cognito認証後、ログイン履歴の保持等、AP側ログイン処理。cognito認証を行わない場合(隊員)は、別途ヘッダを付ける。
         * @summary ログイン処理
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/members/me/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * cognitoサインアウト前、履歴の保持等。cognito認証を行わない場合(隊員)は、別途ヘッダを付ける。
         * @summary ログアウト処理
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/members/me/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NOCAPApi - functional programming interface
 * @export
 */
export const NOCAPApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NOCAPApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 各種登録数の取得（ダッシュボード用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSummaryRegistrations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSummaryRegistrations200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSummaryRegistrations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NOCAPApi.getSummaryRegistrations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * cognito認証後、ログイン履歴の保持等、AP側ログイン処理。cognito認証を行わない場合(隊員)は、別途ヘッダを付ける。
         * @summary ログイン処理
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityAdministrator>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NOCAPApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * cognitoサインアウト前、履歴の保持等。cognito認証を行わない場合(隊員)は、別途ヘッダを付ける。
         * @summary ログアウト処理
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NOCAPApi.logout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NOCAPApi - factory interface
 * @export
 */
export const NOCAPApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NOCAPApiFp(configuration)
    return {
        /**
         * 
         * @summary 各種登録数の取得（ダッシュボード用）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryRegistrations(options?: RawAxiosRequestConfig): AxiosPromise<GetSummaryRegistrations200Response> {
            return localVarFp.getSummaryRegistrations(options).then((request) => request(axios, basePath));
        },
        /**
         * cognito認証後、ログイン履歴の保持等、AP側ログイン処理。cognito認証を行わない場合(隊員)は、別途ヘッダを付ける。
         * @summary ログイン処理
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(options?: RawAxiosRequestConfig): AxiosPromise<EntityAdministrator> {
            return localVarFp.login(options).then((request) => request(axios, basePath));
        },
        /**
         * cognitoサインアウト前、履歴の保持等。cognito認証を行わない場合(隊員)は、別途ヘッダを付ける。
         * @summary ログアウト処理
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NOCAPApi - object-oriented interface
 * @export
 * @class NOCAPApi
 * @extends {BaseAPI}
 */
export class NOCAPApi extends BaseAPI {
    /**
     * 
     * @summary 各種登録数の取得（ダッシュボード用）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NOCAPApi
     */
    public getSummaryRegistrations(options?: RawAxiosRequestConfig) {
        return NOCAPApiFp(this.configuration).getSummaryRegistrations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * cognito認証後、ログイン履歴の保持等、AP側ログイン処理。cognito認証を行わない場合(隊員)は、別途ヘッダを付ける。
     * @summary ログイン処理
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NOCAPApi
     */
    public login(options?: RawAxiosRequestConfig) {
        return NOCAPApiFp(this.configuration).login(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * cognitoサインアウト前、履歴の保持等。cognito認証を行わない場合(隊員)は、別途ヘッダを付ける。
     * @summary ログアウト処理
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NOCAPApi
     */
    public logout(options?: RawAxiosRequestConfig) {
        return NOCAPApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }
}



